import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { HexColorPicker } from "react-colorful";
import { MdFontDownload } from "react-icons/md"; // Add this import at the top
import "../Styles/3d.css";
import "../Styles/ThreeD.css";
import state from "./index.js";
import PositionControl from "./PositionControl";
import { GiPositionMarker, GiTriangleTarget } from "react-icons/gi";
import { snapshot, useSnapshot } from "valtio";
import { FaTrashAlt, FaUserAlt } from "react-icons/fa";
import {
  FaAngleRight,
  FaAngleLeft,
  FaAngleDown,
  FaAngleUp,
} from "react-icons/fa";
import { FaPaintBrush } from "react-icons/fa";
import { IoIosColorPalette } from "react-icons/io";
import { MdGradient, MdSupport } from "react-icons/md";
import {
  TbCircleDottedLetterT,
  TbColorFilter,
  TbGridPattern,
  TbTriangleSquareCircle,
} from "react-icons/tb";
import { TbCircleDashedNumber1 } from "react-icons/tb";
import { FaRegFileImage } from "react-icons/fa";
import { FaMale } from "react-icons/fa";
import { FaFemale } from "react-icons/fa";
import { FaBaby } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import { GLTFExporter } from "three/examples/jsm/exporters/GLTFExporter";
import { useDispatch, useSelector } from "react-redux";
import modelConfig1 from "./modelConfig1.js";
import {
  addCart,
  decreaseModelItems,
  increaseModelItems,
  setSelectedSizeDetails,
  setglbId,
} from "../Redux/Cart_System.js";
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import {
  addToCart,
  addToCartGLB,
  get_glbFile,
  glbGetSize,
  menuSlugSection,
} from "../Services/Operations/ProductAPI.js";
import { useLocation } from "react-router-dom";
import { toJS } from "valtio/utils";
import { toast } from "react-toastify";
import { IoMdDownload } from "react-icons/io";
import { RiFontSize2 } from "react-icons/ri";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import { useNavigate } from "react-router-dom";
import { User2, UserCircle2, UserRound, UsersRound } from "lucide-react";
import { FaChevronLeft } from "react-icons/fa";
import { scale } from "motion";

export const downloadCanvasToImage = () => {
  const canvas = document.querySelector("canvas");
  const dataURL = canvas.toDataURL();
  const link = document.createElement("a");

  link.href = dataURL;
  link.download = "canvas.png";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// function Customizer({ glbFile }) {
function Customizer({ glbFile,activeSection, 
  activeSubSection,
  onSectionClose , currentProduct, onUpdateProduct }) {
      console.log("activeSection : ",activeSection)
  console.log("activeSubSection : ",activeSubSection)
  const fileInputRefs = useRef({});
  const [forceUpdate, setForceUpdate] = useState(false);
  const { configUrl } = useSelector((state) => state.cart);
  const modelItems = useSelector((state) => state.cart.modelItems);
  const [sizes, setSizes] = useState([]);
  const [selectedSize, setSelectedSize] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const sidebarRef = useRef(null);
  const subdesignRef = useRef(null);
  const snap = useSnapshot(state);
  const productData = currentProduct || snap.currentProduct;
  console.log("productData : ", productData);
  console.log("currentProduct : ", currentProduct);
  console.log("snap.currentProduct : ", snap.currentProduct);
  const [isMobile, setIsmobile] = useState(window.innerWidth < 667);
  const [chooseDesign, setChooseDesign] = useState("Design");
  const [addedProducts, setAddedProducts] = useState(["a"]);
  const [frontNumberExpanded, setFrontNumberExpanded] = useState(true); // Default open
  const [backNumberExpanded, setBackNumberExpanded] = useState(true); // Default open
  const [frontTextExpanded, setFrontTextExpanded] = useState(true); // Default open
  const [backTextExpanded, setBackTextExpanded] = useState(true); // Default open
  const [activePatternColor, setActivePatternColor] = useState(null);
  // Update your initial state to use productData
const [frontText, setFrontText] = useState(productData?.frontText || "");
const [backText, setBackText] = useState(productData?.backText || "");
const [frontNumber, setFrontNumber] = useState(productData?.frontNumber || "");
const [backNumber, setBackNumber] = useState(productData?.backNumber || "");
const [frontLogo, setFrontLogo] = useState(productData?.frontLogo || null);
const [backLogo, setBackLogo] = useState(productData?.backLogo || null);
  useEffect(() => {
  // Sync local state with productData when it changes
  setFrontText(productData?.frontText || "");
  setBackText(productData?.backText || "");
  setFrontNumber(productData?.frontNumber || "");
  setBackNumber(productData?.backNumber || "");
  setFrontLogo(productData?.frontLogo || null);
  setBackLogo(productData?.backLogo || null);
}, [productData]);

useEffect(() => {
  console.log("activeSection : ", activeSection);
  console.log("activeSubSection : ", activeSubSection);
  
  if (activeSection === "design") {
    // First close all other sections
    setExpandedSections({
      design: true, // Only open design
      position: false,
      pattern: false,
      colors: false,
      text: false,
      number: false,
      logo: false,
      download: false,
      size: false,
      images: false,
      gradient: false,
      men: false,
      women: false,
      kids: false
    });
    
    // Set the chooseDesign state if provided
    if (activeSubSection) {
      setChooseDesign(activeSubSection);
    }
    
    // Force a re-render if needed
    setForceUpdate(prev => !prev);
  }
}, [activeSection, activeSubSection]);



  // Add these state variables near your other state declarations
  const [categoryExpandedSections, setCategoryExpandedSections] = useState({});
  const [activeGenderFilter, setActiveGenderFilter] = useState("men");
  const staticCategory = [
    {
      id: 1,
      name: "Badminton",
      slug: "men-badminton",
      subcategory: [
        { id: 22, name: "Jersey", slug: "men-jersey" },
        { id: 23, name: "Shorts", slug: "men-shorts" },
        { id: 24, name: "Tank top", slug: "men-tank-top" },
      ],
    },
    {
      id: 2,
      name: "Cycling",
      slug: "men-cycling",
      subcategory: [
        { id: 25, name: "Cycling Jersey", slug: "men-cycling-jersey" },
        { id: 26, name: "Race fit jersey", slug: "men-race-fit-jersey" },
        { id: 27, name: "Winter jersey", slug: "men-winter-jersey" },
        { id: 29, name: "Shorts", slug: "men-cycling-shorts" },
        { id: 30, name: "Tees", slug: "men-tees" },
      ],
    },
    {
      id: 3,
      name: "Cricket",
      slug: "men-cricket",
      subcategory: [
        { id: 31, name: "City collection", slug: "men-city-collection" },
        { id: 32, name: "Jersey", slug: "men-cricket-jersey" },
        { id: 33, name: "Shorts", slug: "men-cricket-shorts" },
        { id: 34, name: "Track pants", slug: "men-track-pants" },
        { id: 35, name: "Whites", slug: "men-whites" },
      ],
    },
    {
      id: 4,
      name: "Running",
      slug: "men-running",
      subcategory: [
        { id: 36, name: "X jersey", slug: "men-x-jersey" },
        { id: 37, name: "Pro jersey", slug: "men-pro-jersey" },
        {
          id: 38,
          name: "Pro tank top jersey",
          slug: "men-pro-tank-top-jersey",
        },
        { id: 39, name: "Shorts", slug: "men-running-shorts" },
      ],
    },
    {
      id: 5,
      name: "Fitness",
      slug: "men-fitness",
      subcategory: [
        { id: 40, name: "Basic T shirt", slug: "men-basic-t-shirt" },
        { id: 41, name: "Pro T shirt", slug: "men-pro-t-shirt" },
        { id: 42, name: "Woven Shorts", slug: "men-woven-shorts" },
        { id: 43, name: "Compression pants", slug: "men-compression-pants" },
        { id: 44, name: "Knitted shorts", slug: "men-knitted-shorts" },
        {
          id: 45,
          name: "Fitness Pro T shirt",
          slug: "men-fitness-pro-t-shirt",
        },
        { id: 46, name: "Singlet", slug: "men-singlet" },
      ],
    },
    {
      id: 6,
      name: "Basketball",
      slug: "men-basketball",
      subcategory: [
        { id: 47, name: "Arm sleeves", slug: "men-arm-sleeves" },
        { id: 48, name: "Jersey", slug: "men-basketball-jersey" },
        { id: 49, name: "Shorts", slug: "men-basketball-shorts" },
      ],
    },
    {
      id: 7,
      name: "Football",
      slug: "men-football",
      subcategory: [
        { id: 50, name: "Jersey", slug: "men-football-jersey" },
        { id: 51, name: "Shorts", slug: "men-football-shorts" },
      ],
    },
  ];
  const [genderCategories, setGenderCategories] = useState({
    men: staticCategory, // Initialize with staticCategory for men
    women: [],
    kids: [],
  });

  // Add this useEffect to initialize category expansion
  useEffect(() => {
    const initialCategoryState = {};
    staticCategory.forEach((cat) => {
      initialCategoryState[cat.id] = false; // Initially collapsed
    });
    setCategoryExpandedSections(initialCategoryState);
  }, []);

  useEffect(() => {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    if (isMobile) {
      const handleClickOutside = (event) => {
        if (
          sidebarRef.current &&
          !sidebarRef.current.contains(event.target) &&
          subdesignRef.current &&
          !subdesignRef.current.contains(event.target)
        ) {
          setExpandedSections({
            design: false,
            position: false,
            pattern: false,
            colors: false,
            text: false,
            number: false,
            logo: false,
            download: false,
            size: false,
            images: false,
            gradient: false,
          });
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, []);

  console.log("configUrl : ", configUrl);
  console.log("glbFile : ", glbFile);
  const dispatch = useDispatch();
  // state.svg = `${configUrl}${glbFile[0].customize_svg}`;
  const designs = glbFile.map((file, index) => ({
    id: file.id,
    name: `design_${index + 1}`,
    image: `${configUrl}${file.customize_image}`,
    model: `${configUrl}${file.customize_file}`,
    svg: `${configUrl}${file.customize_svg}`,
  }));
  const location = useLocation();
  const { menuSlug, subcategorySlug } = location.state || {};
  console.log("Updated designs: ", designs);

  useEffect(() => {
    const fetchSize = async () => {
      if (modelItems.length === 0) {
        dispatch(
          increaseModelItems({
            id: 1,
            menuSlug: "men",
            subcategorySlug: "men-jersey",
            stateGlbFile: glbFile,
          })
        );
      }
      try {
        console.log("glbFile[0] : ", glbFile[0]);
        console.log("glbFile[0].customize_svg : ", glbFile[0].customize_svg);
        state.svg = `${configUrl}${glbFile[0].customize_svg}`;
        const response = await glbGetSize();
        console.log("fetch size : ", response);
        if (response.success) {
          setSizes(response.data);
        }
      } catch (error) {
        console.error("Error fetching:", error);
      }
    };

    fetchSize();
  }, []);

  const staticMenu = [
    { id: 1, name: "Men", slug: "men" },
    { id: 2, name: "Women", slug: "women" },
    { id: 3, name: "Kids", slug: "kids" },
  ];

  const [category, setCategory] = useState(staticCategory);

  const sceneRef = useRef(null);
  const cameraRef = useRef(null);
  // const [frontNumber, setFrontNumber] = useState("");
  const [scene, setScene] = useState(null);
  // const [backNumber, setBackNumber] = useState("");
  const [selectedDesign, setSelectedDesign] = useState(designs[0]);
  const [selectedPattern, setSelectedPattern] = useState({
    front: null,
    back: null,
  });
  const [openedColorPart, setOpenedColorPart] = useState(null);
  const [openedGradientPart, setOpenedGradientPart] = useState(null);
  const [uploadedTexture, setUploadedTexture] = useState(null);
  // const [frontText, setFrontText] = useState("");
  // const [backText, setBackText] = useState("");
  const [parts, setParts] = useState([]);
  const [color, setColor] = useState([]);
  // const [frontLogo, setFrontLogo] = useState(null);
  // const [backLogo, setBackLogo] = useState(null);
  const [partColors, setPartColors] = useState({
    front: "",
    back: "",
  });
  const [openSection, setOpenSection] = useState(null);
  const { tokenDetails } = useSelector((state) => state.user);
  const token = tokenDetails;

  console.log("tokenDetails : ", tokenDetails);

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };
  const navigate = useNavigate();

  console.log("state.parts : ", state.parts);
  const [expandedSections, setExpandedSections] = useState({
    design: true,
    position: false,
    pattern: false,
    colors: false,
    text: false,
    number: false,
    logo: false,
    download: false,
    size: false,
    images: false,
    gradient: false,
  });
  const [activeTextField, setActiveTextField] = useState(null);

  console.log("selectedPattern : ", selectedPattern);

  const [expandedCategories, setExpandedCategories] = useState(() => {
    // Initialize all categories as open (true) for all sections
    const initialExpandedState = {};

    // For men
    staticCategory.forEach((cat) => {
      initialExpandedState[`men-${cat.id}`] = true;
    });

    // For women (assuming same categories)
    staticCategory.forEach((cat) => {
      initialExpandedState[`women-${cat.id}`] = true;
    });

    // For kids (assuming same categories)
    staticCategory.forEach((cat) => {
      initialExpandedState[`kids-${cat.id}`] = true;
    });

    return initialExpandedState;
  });

  const colorOptions = [
    "#fffc5b",
    "#f4cb39",
    "#f6a71a",
    "#f9886c",
    "#f9c1a8",
    "#f16f43",
    "#e8281e",
    "#e01c60",
    "#ae1444",
    "#932045",
    "#d95ca0",
    // "#d9a5d6",
    "#9264ad",
    "#643e72",
    "#601e45",
    "#7a99c8",
    // "#afccf1",
    "#7bb2e1",
    "#2064a6",
    "#134275",
    "#002d4d",
    "#113e74",
    "#5d8cb4",
    "#8acfd1",
    "#4abbb7",
    "#2a928a",
    "#266b6b",
    "#0d3f3f",
    "#8dd2ac",
    "#79c386",
    "#439f52",
    "#265934",
    "#bad14e",
    // "#d9f799",
    // "#faf799",
    "#c2bf4d",
    "#e6b64a",
    "#e98f2f",
    "#f98e7b",
    "#e6504a",
    "#f670b3",
    // "#fbbff2",
    "#d075d6",
    "#9f5cb0",
    // "#d0c0e8",
    "#536896",
    "#95cce6",
    "#5996c2",
    "#234769",
    "#1e6588",
    "#2a998c",
    "#226c54",
    "#5fd99a",
    // "#b8dbab",
    "#0500F7",
  ];

  useEffect(() => {
    setParts([]);
    setColor([]);
    setPartColors({
      front: "",
      back: "",
    });
    state.modelName = designs[0].model;
    // state.parts([]);
  }, [selectedDesign]);

  const initialExpandedState = {};

  // Add this function near your other functions
  const toggleCategory = (categoryId) => {
    setCategoryExpandedSections((prev) => ({
      ...prev,
      [categoryId]: !prev[categoryId],
    }));
  };

  const handleExpandToggle = (section) => {
    setExpandedSections({
      design: section === "design",
      position: section === "position",
      pattern: section === "pattern",
      colors: section === "colors",
      text: section === "text",
      number: section === "number",
      logo: section === "logo",
      download: section === "download",
      size: section === "size",
      images: section === "images",
      gradient: section === "gradient",
      men: section === "men",
      women: section === "women",
      kids: section === "kids",
    });
  };

  const handleColorPartToggle = (part) => {
    setOpenedColorPart((prevPart) => (prevPart === part ? null : part));
  };
  const handleGradientPartToggle = (part) => {
    setOpenedGradientPart((prevPart) => (prevPart === part ? null : part));
  };

  const patterns = [
    { name: "Delete", image: "/asset/img/delete.webp" },
    { name: "Texture0", image: "/asset/spizd_patterns_57.svg", scale: 0.5 },
    { name: "Texture20", image: "/asset/7.svg", scale: 0.8 },
    // { name: "Texture22", image: "/asset/9.svg" },
    { name: "Texture23", image: "/asset/10.svg", scale: 1 },
    { name: "Texture24", image: "/asset/11.svg", scale: 1 },
    { name: "Texture33", image: "/asset/20.svg", scale: 1 },
    // { name: "Texture47", image: "/asset/34.svg" },
    { name: "Texture50", image: "/asset/37.svg", scale: 1 },
    { name: "Texture52", image: "/asset/39.svg", scale: 1 },
    { name: "Texture61", image: "/asset/48.svg", scale: 1 },

    { name: "BankNote", image: "/asset/bank-note_2_preview.svg", scale: 3 },
    // { name: "BathroomFloor", image: "/asset/bathroom-floor_2_preview.svg" },
    { name: "Bubbles", image: "/asset/bubbles_2_preview.svg", scale: 1 },
    {
      name: "CharlieBrown",
      image: "/asset/charlie-brown_2_preview.svg",
      scale: 1,
    },
    {
      name: "EndlessClouds",
      image: "/asset/endless-clouds_2_preview.svg",
      scale: 1,
    },
    {
      name: "FormalInvitation",
      image: "/asset/formal-invitation_2_preview.svg",
      scale: 1.5,
    },
    { name: "Hexagons", image: "/asset/hexagons_2_preview.svg", scale: 1 },

    {
      name: "Pattern1",
      image: "/asset/spized_patterns_1_2_preview.svg",
      scale: 2,
    },
    {
      name: "Pattern2",
      image: "/asset/spized_patterns_2_2_preview.svg",
      scale: 1,
    },

    {
      name: "Pattern4",
      image: "/asset/spized_patterns_4_2_preview.svg",
      scale: 3,
    },

    {
      name: "Pattern6",
      image: "/asset/spized_patterns_6_2_preview.svg",
      scale: 3,
    },
    {
      name: "SpizedPattern7",
      image: "/asset/spized_patterns_7_2_preview.svg",
      scale: 1,
    },

    {
      name: "Pattern12",
      image: "/asset/spized_patterns_12_2_preview.svg",
      scale: 2,
    },
    {
      name: "Pattern21",
      image: "/asset/spized_patterns_21_2_preview.svg",
      scale: 2,
    },
    {
      name: "Pattern22",
      image: "/asset/spized_patterns_22_2_preview.svg",
      scale: 1.5,
    },
    {
      name: "Pattern23",
      image: "/asset/spized_patterns_23_2_preview.svg",
      scale: 4,
    },
    {
      name: "Pattern24",
      image: "/asset/spized_patterns_24_2_preview.svg",
      scale: 3,
    },
    {
      name: "Pattern25",
      image: "/asset/spized_patterns_25_2_preview.svg",
      scale: 3,
    },
    // { name: "Pattern26", image: "/asset/spized_patterns_26_2_preview.svg" },
    // { name: "Pattern30", image: "/asset/spized_patterns_30_2_preview.svg" },
    // { name: "Pattern31", image: "/asset/spized_patterns_31_2_preview.svg" },
    {
      name: "Pattern32",
      image: "/asset/spized_patterns_32_2_preview.svg",
      scale: 3,
    },
    {
      name: "Pattern33",
      image: "/asset/spized_patterns_33_2_preview.svg",
      scale: 3,
    },
    {
      name: "Pattern34",
      image: "/asset/spized_patterns_34_2_preview.svg",
      scale: 3,
    },
    {
      name: "Pattern35",
      image: "/asset/spized_patterns_35_2_preview.svg",
      scale: 3,
    },
    {
      name: "Pattern36",
      image: "/asset/spized_patterns_36_2_preview.svg",
      scale: 3,
    },
    {
      name: "Pattern51",
      image: "/asset/spized_patterns_51_2_preview.svg",
      scale: 4,
    },

    {
      name: "Pattern53",
      image: "/asset/spized_patterns_53_2_preview.svg",
      scale: 4,
    },
    {
      name: "Pattern54",
      image: "/asset/spized_patterns_54_2_preview.svg",
      scale: 4,
    },
    // { name: "Pattern55", image: "/asset/spized_patterns_55_2_preview.svg" },
    {
      name: "Pattern56",
      image: "/asset/spized_patterns_56_2_preview.svg",
      scale: 4,
    },
    {
      name: "Pattern59",
      image: "/asset/spized_patterns_59_2_preview.svg",
      scale: 4,
    },

    {
      name: "Pattern61",
      image: "/asset/spized_patterns_61_2_preview.svg",
      scale: 4,
    },
    {
      name: "Pattern62",
      image: "/asset/spized_patterns_62_2_preview.svg",
      scale: 4,
    },
    {
      name: "Pattern64",
      image: "/asset/spized_patterns_64_2_preview.svg",
      scale: 4,
    },
    {
      name: "Pattern65",
      image: "/asset/spized_patterns_65_2_preview.svg",
      scale: 4,
    },
    {
      name: "Pattern66",
      image: "/asset/spized_patterns_66_2_preview.svg",
      scale: 4,
    },
    {
      name: "Pattern67",
      image: "/asset/spized_patterns_67_2_preview.svg",
      scale: 5,
    },
    {
      name: "Pattern68",
      image: "/asset/spized_patterns_68_2_preview.svg",
      scale: 4,
    },
    {
      name: "Pattern69",
      image: "/asset/spized_patterns_69_2_preview.svg",
      scale: 4,
    },
    {
      name: "Pattern70",
      image: "/asset/spized_patterns_70_2_preview.svg",
      scale: 4,
    },
    {
      name: "Pattern71",
      image: "/asset/spized_patterns_71_2_preview.svg",
      scale: 4,
    },
    {
      name: "Pattern72",
      image: "/asset/spized_patterns_72_2_preview.svg",
      scale: 4,
    },
    {
      name: "Pattern73",
      image: "/asset/spized_patterns_73_2_preview.svg",
      scale: 3,
    },

    {
      name: "Pattern77",
      image: "/asset/spized_patterns_77_2_preview.svg",
      scale: 3.5,
    },
    {
      name: "Pattern78",
      image: "/asset/spized_patterns_78_2_preview.svg",
      scale: 4,
    },

    //  { name: "Texture14", image: "/asset/1.svg" },

    //  { name: "Texture16", image: "/asset/3.svg" },
    //  { name: "Texture17", image: "/asset/4.svg" },

    //  { name: "Texture21", image: "/asset/8.svg" },

    //  { name: "Texture28", image: "/asset/15.svg" },

    //  { name: "Texture30", image: "/asset/17.svg" },
    //  { name: "Texture31", image: "/asset/18.svg" },
    //  { name: "Texture32", image: "/asset/19.svg" },

    //  { name: "Texture34", image: "/asset/21.svg" },

    //  { name: "Texture39", image: "/asset/26.svg" },
    //  { name: "Texture40", image: "/asset/27.svg" },

    //  { name: "Texture43", image: "/asset/30.svg" },

    //  { name: "Texture45", image: "/asset/32.svg" },
    //  { name: "Texture49", image: "/asset/36.svg" },
  ];

  const [logo, setLogo] = useState(null);

  console.log("state.parts : ", state.parts);

  useEffect(() => {
    // Get current product's selected design
    const currentProduct = productData || snap.currentProduct;

    // Only reset if we're dealing with the current product's selected design
    // You might want to track when design changes differently
    if (selectedDesign) {
      // Reset part colors for the current product
      const updatedPartColors = {
        ...currentProduct.partColors,
        front: "",
        back: "",
      };

      handleProductUpdate("partColors", updatedPartColors);
    }
  }, [selectedDesign]);

  const handleFrontTextChange = (e) => {
    const value = e.target.value;
    handleProductUpdate("frontText", value);
    setFrontText(value);
    state.setViewSide('front');
  };

  // Back text handler - Already correct
  const handleBackTextChange = (e) => {
    const value = e.target.value;
    handleProductUpdate("backText", value);
    setBackText(value);
    state.setViewSide('back');
  };

  // Front number handler - ADD THIS
  const handleFrontNumberChange = (e) => {
    const value = e.target.value;
    handleProductUpdate("frontNumber", value);
    setFrontNumber(value);
    state.setViewSide('front');
  };

  // Back number handler - ADD THIS
  const handleBackNumberChange = (e) => {
    const value = e.target.value;
    handleProductUpdate("backNumber", value);
    setBackNumber(value);
    state.setViewSide('back');
  };

  const handleInputFocus = (side) => {
  state.setViewSide(side);
};

  // Font selection handlers - Already correct
  const handleTextFontChange = (font, side) => {
    const newFonts = {
      ...productData.textFonts,
      [side]: font,
    };
    handleProductUpdate("textFonts", newFonts);
  };

  const handleNumberFontChange = (font, side) => {
    const newFonts = {
      ...productData.numberFonts,
      [side]: font,
    };
    handleProductUpdate("numberFonts", newFonts);
  };

  // Text color handler
  const handleTextColorChange = (side, color) => {
    const updatedColors = {
      ...productData.textColors,
      [side]: color,
    };
    handleProductUpdate("textColors", updatedColors);
  };

  // Number color handler
  const handleNumberColorChange = (side, color) => {
    const updatedColors = {
      ...productData.numberColors,
      [side]: color,
    };
    handleProductUpdate("numberColors", updatedColors);
  };

  // Logo upload handlers - UPDATE THESE
  const frontHandleLogoUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        handleProductUpdate("frontLogo", e.target.result);
        setFrontLogo(e.target.result);
        console.log("front logo : ", e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const backHandleLogoUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        handleProductUpdate("backLogo", e.target.result);
        setBackLogo(e.target.result);
        console.log("back logo : ", e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // Logo delete handlers - ADD THESE
  const handleDeleteFrontLogo = () => {
    handleProductUpdate("frontLogo", null);
    setFrontLogo(null);
  };

  const handleDeleteBackLogo = () => {
    handleProductUpdate("backLogo", null);
    setBackLogo(null);
  };
  const handlePatternSelect = (part, pattern) => {
    if (pattern.name === "Delete") {
      // Remove pattern for this part
      const newSelectedPattern = { ...productData.selectedPattern };
      delete newSelectedPattern[part.toUpperCase()];
      handleProductUpdate("selectedPattern", newSelectedPattern);

      // Also clear pattern color
      const newPatternColors = { ...productData.patternColors };
      delete newPatternColors[part.toUpperCase()];
      handleProductUpdate("patternColors", newPatternColors);
    } else {
      // Add pattern with its scale
      const newSelectedPattern = {
        ...productData.selectedPattern,
        [part.toUpperCase()]: {
          name: pattern.name,
          image: pattern.image,
          scale: pattern.scale || 1, // Use pattern scale or default
        },
      };
      handleProductUpdate("selectedPattern", newSelectedPattern);
    }
  };
  const handleFileUpload = (event, part) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      console.error("Please select a valid image file");
      return;
    }

    const originalImg = new Image();
    const originalUrl = URL.createObjectURL(file);

    originalImg.onload = () => {
      const reader = new FileReader();
      reader.onload = function (e) {
        const imageUrl = e.target.result;

        const newImageData = {
          name: "Custom",
          image: imageUrl,
          fileName: file.name,
          originalWidth: originalImg.width,
          originalHeight: originalImg.height,
        };

        // Update imagesPattern for current product
        const newImagesPattern = {
          ...productData.imagesPattern,
          [part]: newImageData,
        };

        handleProductUpdate("imagesPattern", newImagesPattern);
      };

      reader.readAsDataURL(file);
      URL.revokeObjectURL(originalUrl);
    };

    originalImg.src = originalUrl;
  };
  // const designHandler = (design) => {
  //   console.log("Selected Design:", design);

  //   if (design.svg) {
  //     handleProductUpdate("svg", design.svg);
  //   }

  //   setSelectedPattern({
  //     front: productData.selectedPattern?.front || null,
  //     back: productData.selectedPattern?.back || null,
  //   });

  //   setSelectedDesign(design);
  //   dispatch(setglbId(design.id));

  //   // Update model name for the current product
  //   handleProductUpdate("modelName", design.model);
  //   console.log("Updated modelName:", design.model);
  // };
const designHandler = (design) => {
  console.log("Selected Design:", design);

  if (design.svg) {
    handleProductUpdate("svg", design.svg);
  }

  setSelectedPattern({
    front: productData.selectedPattern?.front || null,
    back: productData.selectedPattern?.back || null,
  });

  setSelectedDesign(design);
  dispatch(setglbId(design.id));

  handleProductUpdate("modelName", design.model);
 
  state.modelName = design.model;
 
  state.updateTrigger++;

  console.log("Updated modelName:", design.model);
};
  useEffect(() => {
    if (glbFile.length > 0) {
      dispatch(setglbId(glbFile[0].id));
    }
  }, [glbFile, dispatch]);

  const canvasRef = useRef(null); // Create a ref to store the canvas reference

  useEffect(() => {
    console.log("imagesPattern : ", state.imagesPattern);
  }, [state.imagesPattern]);

  const handleSizeSelect = (size) => {
    console.log("size : ", size);
    setSelectedSize(size);
    dispatch(setSelectedSizeDetails(size));
  };

  const handleMenuCategory = async (name) => {
    try {
      const formData = new FormData();
      formData.append("slug", name);
      const response = await menuSlugSection(formData);

      if (response.success === true) {
        // Store categories per gender
        setGenderCategories((prev) => ({
          ...prev,
          [name]: response.data.category || [],
        }));

        // Set active gender
        setActiveGenderFilter(name);
      }
    } catch (error) {
      console.log("Failed to get category", error);
      setGenderCategories((prev) => ({
        ...prev,
        [name]: [],
      }));
    }
  };

  const extractBaseSlug = (slug) => {
    const prefixes = ["men-", "women-", "kids-"];
    for (const prefix of prefixes) {
      if (slug.startsWith(prefix)) {
        return slug.substring(prefix.length);
      }
    }
    return slug;
  };

  const handel3dRender = async (menu, data) => {
    console.log(data);

    try {
      const formData = new FormData();

      formData.append("subcategoryId", data.id);

      const result = await get_glbFile(formData);
      console.log("GLB Data:", result);

      if (result.success && result.data) {
        navigate("/3d-product", {
          state: {
            menuSlug: menu,
            subcategorySlug: data.slug,
            glbFile: result.data,
          },
        });
        window.location.reload();
      } else {
        toast.error("No 3D model available. Please try another product.");
      }

      console.log("details", {
        menuSlug: menu,
        subcategorySlug: data.slug,
        glbFile: result.data,
      });
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong. Please try again later.");
    }
  };

  const formatText = (text) => {
    const lower = text.toLowerCase();

    // First handle special cases
    const partMappings = {
      rightsleve: "Right Sleeve",
      leftsleve: "Left Sleeve",
      "logo.001": "Logo 1",
      "logo.002": "Logo 2",
      "design.002": "Design 2",
      "neck.002": "Neck 2",
      "material #43": "Material",
    };

    // Check if we have a mapping for this part
    if (partMappings[text]) {
      return partMappings[text];
    }

    // For other parts, capitalize first letter and handle camelCase
    let formatted = lower.charAt(0).toUpperCase() + lower.slice(1);

    // Add space before capital letters (for camelCase parts)
    formatted = formatted.replace(/([A-Z])/g, " $1").trim();

    return formatted;
  };
  const EXCLUDED_PARTS_PATTERN = [
    "LOGO",
    "SLEVES",
    "BAND",
    "NECK.002",
    "LOGO.002",
    "DESIGN.002",
    "BUTTONS",
    "DESIGN",
    "NECK",
    "Material #43",
    "BUTTON",
    "LOGO.001",
    "ZIPPER",
  ];

  const EXCLUDED_PARTS_IMAGES = [
    "LOGO",
    "BUTTONS",
    "SLEVES",
    "NECK.002",
    "LOGO.002",
    "DESIGN.002",
    "BUTTON",
    "BAND",
    "LOGO.001",
    "DESIGN",
    "NECK",
    "Material #43",
    "ZIPPER",
  ];

  const EXCLUDED_PARTS_COLORS = [
    "LOGO",
    "LOGO.002",
    "BAND",
    "LOGO.001",
    "BUTTONS",
    "BUTTON",
    "Material #43",
    "ZIPPER",
  ];

  const EXCLUDED_PARTS_GRADIENT = [
    "LOGO",
    "SLEVES",
    "DESIGN",
    "NECK",
    "ZIPPER",
  ];

  // Create a part name mapping object
  const PART_NAME_MAPPINGS = {
    RIGHTSLEVE: "Right Sleeve",
    LEFTSLEVE: "Left Sleeve",
    "LOGO.001": "Logo 1",
    "LOGO.002": "Logo 2",
    "DESIGN.002": "Design 2",
    "NECK.002": "Neck 2",
    "Material #43": "Material",
  };

  const getDisplayName = (part) => {
    return PART_NAME_MAPPINGS[part] || formatText(part);
  };
  useEffect(() => {
    console.log("Component mounted with config:", {
      newKey: snap.newKey,
      config: modelConfig1[snap.newKey],
    });
  }, []);
  // -------------------------
  const handleProductUpdate = (key, value) => {
    if (onUpdateProduct) {
      onUpdateProduct(key, value);
    } else {
      // Fallback to global state update
      state.updateCurrentProduct(key, value);
    }
  };

  // For part colors
  const handlePartColorChange = (part, color) => {
    const updatedColors = {
      ...productData.partColors,
      [part]: color,
    };
    handleProductUpdate("partColors", updatedColors);
  };

  // For gradient colors
  const handleGradientColorChange = (part, color) => {
    const updatedColors = {
      ...productData.gradientColors,
      [part]: color,
    };
    handleProductUpdate("gradientColors", updatedColors);
  };

  // For pattern colors
  const handlePatternColorChange = (patternName, color) => {
    const updatedColors = {
      ...productData.patternColors,
      [patternName.toUpperCase()]: color,
    };
    handleProductUpdate("patternColors", updatedColors);
  };

  

  return (
    <div
      className="containerSection"
      style={{ height: isMobile ? "70vh" : "100%", overflow: "auto" }}
    >
      <div
        className="sidebar sidebar3"
        ref={sidebarRef}
        style={{
          padding: 0,
          borderRight: "1px solid #cbc6c6",

          overflowY: isMobile ? "hidden" : "auto",
        }}
      >
        {/* Men Section - Modified to open Design section with Category tab */}
        <div className="text-editor margin-sidebar">
          <div
            onClick={() => {
              // Open the Design section
              handleExpandToggle("design");
              // Set the active tab to "category"
              setChooseDesign("category");
              // Set the active gender filter (optional)
              setActiveGenderFilter("men");
              handleMenuCategory("men");
            }}
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              width: "100%",
              borderBottom: "1px solid #cbc6c6",
              gap: "4px",
              padding: "4px 0px",
              height: isMobile ? "70px" : "50px",
            }}
          >
            <div
              style={{
                borderRadius: isMobile ? "50%" : "0px",
                border: isMobile
                  ? expandedSections.design && chooseDesign === "category"
                    ? "1px solid #1f23fcff"
                    : "1px solid #ccc"
                  : "",
                boxShadow: isMobile ? "0 0 10px rgba(0,0,0,0.2)" : "",
                padding: isMobile ? "4px" : "0px",
                background: "#fff",
              }}
            >
              <UserRound
                size={20}
                color={
                  expandedSections.design && activeGenderFilter === "men"
                    ? "#000000"
                    : "#8d8c8cff"
                }
              />
            </div>
            <p
              onClick={() => {
                handleExpandToggle("design");
                setChooseDesign("category");
                setActiveGenderFilter("men");
                handleMenuCategory("men");
              }}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                fontSize: "10px",
                fontWeight: "400",
                marginBottom: "0px",
                color:
                  expandedSections.design && activeGenderFilter === "men"
                    ? "#000000"
                    : "#8d8c8cff",
              }}
            >
              Men
            </p>
          </div>
        </div>

        {/* Women Section */}
        <div className="text-editor">
          <div
            onClick={() => {
              handleExpandToggle("design");
              setChooseDesign("category");
              setActiveGenderFilter("women");
              handleMenuCategory("women");
            }}
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              width: "100%",
              borderBottom: "1px solid #cbc6c6",
              gap: "4px",
              padding: "4px 0px",
              height: isMobile ? "70px" : "50px",
            }}
          >
            <div
              style={{
                borderRadius: isMobile ? "50%" : "0px",
                border: isMobile
                  ? expandedSections.design && chooseDesign === "category"
                    ? "1px solid #1f23fcff"
                    : "1px solid #ccc"
                  : "",
                boxShadow: isMobile ? "0 0 10px rgba(0,0,0,0.2)" : "",
                padding: isMobile ? "4px" : "0px",
                background: "#fff",
              }}
            >
              <FaUserAlt
                size={20}
                color={
                  expandedSections.design && activeGenderFilter === "women"
                    ? "#000000"
                    : "#8d8c8cff"
                }
              />
            </div>
            <p
              onClick={() => {
                handleExpandToggle("design");
                setChooseDesign("category");
                setActiveGenderFilter("women");
                handleMenuCategory("women");
              }}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                fontSize: "10px",
                fontWeight: "400",
                marginBottom: "0px",
                color:
                  expandedSections.design && activeGenderFilter === "women"
                    ? "#000000"
                    : "#8d8c8cff",
              }}
            >
              Women
            </p>
          </div>
        </div>

        {/* Kids Section */}
        <div className="text-editor">
          <div
            onClick={() => {
              handleExpandToggle("design");
              setChooseDesign("category");
              setActiveGenderFilter("kids");
              handleMenuCategory("kids");
            }}
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              width: "100%",
              borderBottom: "1px solid #cbc6c6",
              gap: "4px",
              padding: "4px 0px",
              height: isMobile ? "70px" : "50px",
            }}
          >
            <div
              style={{
                borderRadius: isMobile ? "50%" : "0px",
                border: isMobile
                  ? expandedSections.design && chooseDesign === "category"
                    ? "1px solid #1f23fcff"
                    : "1px solid #ccc"
                  : "",
                boxShadow: isMobile ? "0 0 10px rgba(0,0,0,0.2)" : "",
                padding: isMobile ? "4px" : "0px",
                background: "#fff",
              }}
            >
              <UsersRound
                style={{ fontSize: "16px" }}
                color={
                  expandedSections.design && activeGenderFilter === "kids"
                    ? "#000000"
                    : "#8d8c8cff"
                }
              />
            </div>
            <p
              onClick={() => {
                handleExpandToggle("design");
                setChooseDesign("category");
                setActiveGenderFilter("kids");
                handleMenuCategory("kids");
              }}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                fontSize: "10px",
                fontWeight: "400",
                marginBottom: "0px",
                color:
                  expandedSections.design && activeGenderFilter === "kids"
                    ? "#000000"
                    : "#8d8c8cff",
              }}
            >
              Kids
            </p>
          </div>
        </div>
        {/* Design Section */}
        <div
          className="text-editor"
          style={{
            borderBottom: "1px solid #cbc6c6",
            borderRadius: "0px",
          }}
        >
          <div
            onClick={() => handleExpandToggle("design")}
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              width: "100%",

              gap: "4px",
              padding: "4px 0px",
              height: isMobile ? "70px" : "50px",
            }}
          >
            <div
              style={{
                borderRadius: isMobile ? "50%" : "0px",
                border: isMobile
                  ? expandedSections.design
                    ? "1px solid #1f23fcff"
                    : "1px solid #ccc"
                  : "",
                boxShadow: isMobile ? "0 0 10px rgba(0,0,0,0.2)" : "",
                padding: isMobile ? "4px" : "0px",
                background: "#fff",
              }}
            >
              <TbTriangleSquareCircle
                size={20}
                color={expandedSections.design ? "#000000" : "#8d8c8cff"}
              />
            </div>

            <p
              onClick={() => handleExpandToggle("design")}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                fontSize: "10px",
                fontWeight: "500",
                marginBottom: "0px",
                color: expandedSections.design ? "#000000" : "#8d8c8cff",
              }}
              className="design-sidebar"
            >
              Design
            </p>
          </div>
        </div>

        {/* Pattern Section */}
        <div className="text-editor">
          <div
            onClick={() => handleExpandToggle("pattern")}
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              width: "100%",
              borderBottom: "1px solid #cbc6c6",
              // justifyContent: "space-between",
              gap: "4px",
              padding: "4px 0px",
              height: isMobile ? "70px" : "50px",
            }}
          >
            {" "}
            <div
              style={{
                borderRadius: isMobile ? "50%" : "0px",
                border: isMobile
                  ? expandedSections.pattern
                    ? "1px solid #1f23fcff"
                    : "1px solid #ccc"
                  : "",
                boxShadow: isMobile ? "0 0 10px rgba(0,0,0,0.2)" : "",
                padding: isMobile ? "4px" : "0px",
                background: "#fff",
              }}
            >
              <TbGridPattern
                style={{ fontSize: "20px" }}
                color={expandedSections.pattern ? "#000000" : "#8d8c8cff"}
              />
            </div>
            <p
              onClick={() => handleExpandToggle("pattern")}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                fontSize: "10px",
                fontWeight: "500",
                marginBottom: "0px",
                color: expandedSections.pattern ? "#000000" : "#8d8c8cff",
              }}
            >
              Pattern
            </p>
          </div>
        </div>

        {/* images Section */}
        <div className="text-editor">
          <div
            onClick={() => handleExpandToggle("images")}
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              width: "100%",
              borderBottom: "1px solid #cbc6c6",
              // justifyContent: "space-between",
              gap: "4px",
              padding: "4px 0px",
              height: isMobile ? "70px" : "50px",
            }}
          >
            {" "}
            <div
              style={{
                borderRadius: isMobile ? "50%" : "0px",
                border: isMobile
                  ? expandedSections.images
                    ? "1px solid #1f23fcff"
                    : "1px solid #ccc"
                  : "",
                boxShadow: isMobile ? "0 0 10px rgba(0,0,0,0.2)" : "",
                padding: isMobile ? "4px" : "0px",
                background: "#fff",
              }}
            >
              <MdGradient
                style={{ fontSize: "20px" }}
                color={expandedSections.images ? "#000000" : "#8d8c8cff"}
              />
            </div>
            <p
              onClick={() => handleExpandToggle("images")}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                fontSize: "10px",
                fontWeight: "500",
                marginBottom: "0px",
                color: expandedSections.images ? "#000000" : "#8d8c8cff",
              }}
            >
              Images
            </p>
          </div>
        </div>

        {/* Colors Section */}
        <div className="text-editor">
          <div
            onClick={() => handleExpandToggle("colors")}
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              width: "100%",
              borderBottom: "1px solid #cbc6c6",
              //  justifyContent: "space-between",
              gap: "4px",
              padding: "4px 0px",
              height: isMobile ? "70px" : "50px",
            }}
          >
            {" "}
            <div
              style={{
                borderRadius: isMobile ? "50%" : "0px",
                border: isMobile
                  ? expandedSections.colors
                    ? "1px solid #1f23fcff"
                    : "1px solid #ccc"
                  : "",
                boxShadow: isMobile ? "0 0 10px rgba(0,0,0,0.2)" : "",
                padding: isMobile ? "4px" : "0px",
                background: "#fff",
              }}
            >
              <TbColorFilter
                style={{ fontSize: "20px" }}
                color={expandedSections.colors ? "#000000" : "#8d8c8cff"}
              />
            </div>
            <p
              onClick={() => handleExpandToggle("colors")}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                fontSize: "10px",
                fontWeight: "500",
                marginBottom: "0px",
                color: expandedSections.colors ? "#000000" : "#8d8c8cff",
              }}
            >
              Colors{" "}
            </p>
          </div>
        </div>

        {/* Gradient Section */}
        <div className="text-editor">
          <div
            onClick={() => handleExpandToggle("gradient")}
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              width: "100%",
              borderBottom: "1px solid #cbc6c6",
              // justifyContent: "space-between",
              gap: "4px",
              padding: "4px 0px",
              height: isMobile ? "70px" : "50px",
            }}
          >
            {" "}
            <div
              style={{
                borderRadius: isMobile ? "50%" : "0px",
                border: isMobile
                  ? expandedSections.gradient
                    ? "1px solid #1f23fcff"
                    : "1px solid #ccc"
                  : "",
                boxShadow: isMobile ? "0 0 10px rgba(0,0,0,0.2)" : "",
                padding: isMobile ? "4px" : "0px",
                background: "#fff",
              }}
            >
              <IoIosColorPalette
                style={{ fontSize: "20px" }}
                color={expandedSections.gradient ? "#000000" : "#8d8c8cff"}
              />
            </div>
            <p
              onClick={() => handleExpandToggle("gradient")}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                fontSize: "10px",
                fontWeight: "500",
                marginBottom: "0px",
                color: expandedSections.gradient ? "#000000" : "#8d8c8cff",
              }}
            >
              Gradient{" "}
            </p>
          </div>
        </div>

        {/* Text Section */}
        <div className="text-editor">
          <div
            onClick={() => handleExpandToggle("text")}
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              width: "100%",
              borderBottom: "1px solid #cbc6c6",
              //  justifyContent: "space-between",
              gap: "4px",
              padding: "4px 0px",
              height: isMobile ? "70px" : "50px",
            }}
          >
            {" "}
            <div
              style={{
                borderRadius: isMobile ? "50%" : "0px",
                border: isMobile
                  ? expandedSections.text
                    ? "1px solid #1f23fcff"
                    : "1px solid #ccc"
                  : "",
                boxShadow: isMobile ? "0 0 10px rgba(0,0,0,0.2)" : "",
                padding: isMobile ? "4px" : "0px",
                background: "#fff",
              }}
            >
              <TbCircleDottedLetterT
                style={{ fontSize: "20px" }}
                color={expandedSections.text ? "#000000" : "#8d8c8cff"}
              />
            </div>
            <p
              onClick={() => handleExpandToggle("text")}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                fontSize: "10px",
                fontWeight: "500",
                marginBottom: "0px",
                color: expandedSections.text ? "#000000" : "#8d8c8cff",
              }}
            >
              Text{" "}
            </p>
          </div>
        </div>

        {/* Number Section */}
        <div className="text-editor">
          <div
            onClick={() => handleExpandToggle("number")}
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              width: "100%",
              borderBottom: "1px solid #cbc6c6",
              //  justifyContent: "space-between",
              gap: "4px",
              padding: "4px 0px",
              height: isMobile ? "70px" : "50px",
            }}
          >
            {" "}
            <div
              style={{
                borderRadius: isMobile ? "50%" : "0px",
                border: isMobile
                  ? expandedSections.number
                    ? "1px solid #1f23fcff"
                    : "1px solid #ccc"
                  : "",
                boxShadow: isMobile ? "0 0 10px rgba(0,0,0,0.2)" : "",
                padding: isMobile ? "4px" : "0px",
                background: "#fff",
              }}
            >
              <TbCircleDashedNumber1
                style={{ fontSize: "20px" }}
                color={expandedSections.number ? "#000000" : "#8d8c8cff"}
              />
            </div>
            <p
              onClick={() => handleExpandToggle("number")}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                fontSize: "10px",
                fontWeight: "500",
                marginBottom: "0px",
                color: expandedSections.number ? "#000000" : "#8d8c8cff",
              }}
            >
              Number
            </p>
          </div>
        </div>

        <div className="text-editor">
          <div
            onClick={() => handleExpandToggle("logo")}
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              width: "100%",
              borderBottom: "1px solid #cbc6c6",
              // justifyContent: "space-between",
              gap: "4px",
              padding: "4px 0px",
              height: isMobile ? "70px" : "50px",
            }}
          >
            {" "}
            <div
              style={{
                borderRadius: isMobile ? "50%" : "0px",
                border: isMobile
                  ? expandedSections.logo
                    ? "1px solid #1f23fcff"
                    : "1px solid #ccc"
                  : "",
                boxShadow: isMobile ? "0 0 10px rgba(0,0,0,0.2)" : "",
                padding: isMobile ? "4px" : "0px",
                background: "#fff",
              }}
            >
              <FaRegFileImage
                style={{ fontSize: "20px" }}
                color={expandedSections.logo ? "#000000" : "#8d8c8cff"}
              />
            </div>
            <p
              onClick={() => handleExpandToggle("logo")}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                fontSize: "10px",
                fontWeight: "500",
                marginBottom: "0px",
                color: expandedSections.logo ? "#000000" : "#8d8c8cff",
              }}
            >
              Logo{" "}
            </p>
          </div>
        </div>

        <div className="text-editor">
          <div
            onClick={() => handleExpandToggle("size")}
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              width: "100%",
              borderBottom: "1px solid #cbc6c6",
              //  justifyContent: "space-between",
              gap: "4px",
              padding: "4px 0px",
              height: isMobile ? "70px" : "50px",
            }}
          >
            {" "}
            <div
              style={{
                borderRadius: isMobile ? "50%" : "0px",
                border: isMobile
                  ? expandedSections.size
                    ? "1px solid #1f23fcff"
                    : "1px solid #ccc"
                  : "",
                boxShadow: isMobile ? "0 0 10px rgba(0,0,0,0.2)" : "",
                padding: isMobile ? "4px" : "0px",
                background: "#fff",
              }}
            >
              <RiFontSize2
                style={{ fontSize: "20px" }}
                color={expandedSections.size ? "#000000" : "#8d8c8cff"}
              />
            </div>
            <p
              onClick={() => handleExpandToggle("size")}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                fontSize: "10px",
                fontWeight: "500",
                marginBottom: "0px",
                color: expandedSections.size ? "#000000" : "#8d8c8cff",
              }}
              className="design-sidebar"
            >
              Size
            </p>
          </div>
        </div>
      </div>

      <div className="download-section">
        <div
          className={`Subdesign-section ${
            expandedSections.download ? "show" : ""
          }`}
          ref={subdesignRef}
        >
          <div className="design-section1">
            {expandedSections.download && (
              <div
                className="input-group"
                style={{
                  marginTop: "27px",
                  zIndex: "100",
                  height: "fit-content",
                  padding: "0px 10px",
                  opacity: "1",
                  position: "relative",
                }}
              >
                <button
                  onClick={downloadCanvasToImage}
                  style={{
                    width: "100%",
                    margin: "auto",
                    marginTop: "7px",
                    padding: "10px",
                    backgroundColor: "grey",
                    color: "white",
                  }}
                >
                  Download as PNG
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="download-section">
        <div
          className={`Subdesign-section ${expandedSections.size ? "show" : ""}`}
          ref={subdesignRef}
        >
          <div style={{ width: "100%", fontSize: "7px" }}>
            {expandedSections.size && (
              <div
                className="input-group"
                style={{
                  marginTop: isMobile ? "28px" : "130px",
                  zIndex: "100",
                  height: "fit-content",
                  padding: "0px 10px",
                  opacity: "1",
                  position: "relative",
                  display: "flex",
                  flexDirection: "row",
                  borderRight: "1px solid rgb(203, 198, 198)",
                }}
              >
                {sizes.map((size) => (
                  <button
                    key={size.id}
                    onClick={() => handleSizeSelect(size)}
                    style={{
                      margin: "5px",
                      padding: "6px 12px",
                      border: "1px solid #333",
                      borderRadius: "8px",
                      backgroundColor:
                        selectedSize?.id === size.id
                          ? "rgb(40, 56, 84)"
                          : "#fff",
                      color:
                        selectedSize?.id === size.id
                          ? "#fff"
                          : "rgb(40, 56, 84)",
                      cursor: "pointer",
                      transition: "background-color 0.3s",
                      width: "max-content",
                      fontSize: "10px",
                    }}
                  >
                    {size.name}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      <div>
        {!isMobile && (
          <div
            style={{
              top: 0,
              position: "fixed",
              backgroundColor: "white",
              width: "40vw",
              height: "130px",
              left: 0,
              zIndex: 999,
            }}
          ></div>
        )}
      </div>
      {/* select design tab */}
      {/* select design tab */}
      <div
        style={{
          visibility: isMobile ? "hidden" : "visible",
          position: "absolute",
          width: "20%",
          top: isMobile ? "10px" : "66px",
          left: isMobile ? "50%" : "101px",
          zIndex: 999,
          padding: "0 8px",
          backgroundColor: "white",
          borderBottom: "1px solid #cbc6c6",
          borderRight: "1px solid rgb(203, 198, 198)",
          paddingTop: "20px",
          fontFamily: "Poppins, sans-serif",
        }}
      >
        <p
          style={{
            padding: 0,
            margin: 0,
            fontWeight: 400,
            fontSize: "16px",
            fontFamily: "Poppins, sans-serif",
            lineHeight: "100%",
            letterSpacing: "0px",
          }}
        >
          Select a Design
        </p>
        <p
          style={{
            padding: 0,
            margin: 0,
            fontSize: "8px",
            fontWeight: 400,
            fontFamily: "Poppins, sans-serif",
          }}
        >
          Choose a standard design
        </p>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: expandedSections.design ? "space-evenly" : "center",
            gap: "10px",
            width: "100%",
          }}
        >
          {expandedSections.design && (
            <p
              onClick={() => setChooseDesign("category")}
              style={{
                paddingTop: "10px",
                margin: 0,
                fontSize: "13px",
                fontWeight: 500,
                cursor: "pointer",
                borderBottom:
                  chooseDesign === "category" ? "1px solid black" : "",
                fontFamily: "Poppins, sans-serif",
              }}
            >
              Category
            </p>
          )}
          <p
            onClick={() => setChooseDesign("Design")}
            style={{
              paddingTop: "10px",
              margin: 0,
              fontSize: "13px",
              fontWeight: 500,
              cursor: "pointer",
              borderBottom: chooseDesign === "Design" ? "1px solid black" : "",
              fontFamily: "Poppins, sans-serif",
            }}
          >
            {expandedSections.design
              ? "Design"
              : expandedSections.pattern
              ? "Pattern"
              : expandedSections.images
              ? "Images"
              : expandedSections.colors
              ? "Colors"
              : expandedSections.gradient
              ? "Gradient"
              : expandedSections.text
              ? "Text"
              : expandedSections.number
              ? "Number"
              : expandedSections.logo
              ? "Logo"
              : expandedSections.size
              ? "Size"
              : expandedSections.men
              ? "Men"
              : expandedSections.women
              ? "Women"
              : expandedSections.kids
              ? "Kids"
              : "Design"}
          </p>
        </div>
      </div>

      {/* add product tab */}
      {/* <div
  style={{
    visibility: isMobile ? "hidden" : "visible",
    position: "absolute",
    width: "fit-content",
    bottom: "55px",
    left: isMobile ? "50%" : "29%",
    zIndex: 9999,
    padding: "0 8px",
    backgroundColor: "white",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    cursor: "pointer",
    fontFamily: "Poppins, sans-serif",
    borderRadius: "4px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  }}
>
  {modelItems.length > 0 &&
    modelItems.map((item, ind) => (
      <div
        key={item.id}
        style={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          backgroundColor: "rgba(21, 93, 226, 1)",
          borderRadius: "4px",
          padding: "5px 8px",
          paddingRight: "12px", // Extra padding for the cross icon
        }}
      >
        <p
          onClick={() => {
            // Handle product selection
            console.log("Selecting product:", item.id);
            // Add your product selection logic here
          }}
          style={{
            fontSize: "12px",
            color: "white",
            fontFamily: "Poppins, sans-serif",
            margin: 0,
            cursor: "pointer",
          }}
        >
          Product {ind + 1}
        </p>
        

        <span
          onClick={(e) => {
            e.stopPropagation(); // Prevent triggering the parent click
            console.log("Removing product:", item.id);
            dispatch(decreaseModelItems(item.id));
          }}
          style={{
            position: "absolute",
            right: "-7px",
            top: "2%",
            transform: "translateY(-50%)",
            color: "red",
            fontSize: "10px",
            cursor: "pointer",
            padding: "2px",
            borderRadius: "50%",
            width: "19px",
            height: "19px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "white",
            transition: "background-color 0.2s",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.3)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.2)";
          }}
        >
         <RxCross2 style={{fontSize : "19px"}}/>
        </span>
      </div>
    ))}
    
  <p
    onClick={() => {
      console.log({
        id: modelItems.length + 1,
        menuSlug,
        subcategorySlug,
        glbFile,
      });

      dispatch(
        increaseModelItems({
          id: modelItems.length + 1,
          menuSlug,
          subcategorySlug,
          glbFile,
        })
      );
    }}
    style={{
      fontSize: "12px",
      borderBottom: "1px solid #cbc6c6",
      padding: "5px",
      fontFamily: "Poppins, sans-serif",
      margin: 0,
      cursor: "pointer",
      transition: "color 0.2s",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.color = "rgba(21, 93, 226, 1)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.color = "inherit";
    }}
  >
    + Add new product
  </p>
</div> */}

{(expandedSections.design || activeSection === "design") && (
        <div
          className={`Subdesign-section Subdesign-section2 ${
            expandedSections.design ? "show" : ""
          }`}
          ref={subdesignRef}
          style={{
            height: isMobile ? "140px" : "",
            fontFamily: "Poppins, sans-serif",
          }}
        >
          <div
            className="design-section1 design-section-padding"
            style={{ width: "100%", backgroundColor: "#fff" }}
          >
            {/* Show Design thumbnails when "Design" tab is active */}
            {chooseDesign === "Design" ? (
              <div
                className="design-section design-section3"
                style={{
                  overflowY: isMobile ? "hidden" : "scroll",
                  overflowX: isMobile ? "scroll" : "hidden",
                  width: isMobile ? "100vw" : "",
                  minWidth: isMobile ? "100vw" : "",
                  maxWidth: isMobile ? "fit-content" : "",
                  display: "flex",
                  flexWrap: isMobile ? "nowrap" : "wrap",
                  alignItems: isMobile ? "" : "center",
                  justifyContent: isMobile ? "" : "center",
                  borderRight: "1px solid rgb(203, 198, 198)",
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                {designs.map((design) => (
                  <div
                    key={design.name}
                    className={`design-thumbnail ${
                      selectedDesign.name === design.name ? "active" : ""
                    }`}
                    style={{
                      border:
                        selectedDesign.name === design.name
                          ? "2px solid blue"
                          : "1px solid gray",
                      padding: "5px",
                      borderRadius: "5px",
                      cursor: "pointer",
                      maxHeight: "fit-content",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      // height: isMobile ? "60px" : "90px",
                      // width: isMobile ? "60px" : "90px",
                      //  height: isMobile ? "60px" : "50%",
                      width: isMobile ? "60px" : "46%",
                      flexShrink: 0,
                    }}
                    onClick={() => designHandler(design)}
                  >
                    <img
                      className="design-section-image"
                      src={design.image}
                      alt={design.name}
                      style={{
                        // height: "70px",
                        // width: "70px",
                        width: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                ))}
              </div>
            ) : (
              /* Show Categories when "Category" tab is active */
              <div
                className="category-section"
                style={{
                  overflowY: "auto",
                  marginTop: "33px",
                  padding: "10px",
                  borderRight: "1px solid rgb(203, 198, 198)",
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                {/* Active Gender Header */}
                {/* <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginBottom: "15px",
              padding: "10px",
              backgroundColor: "#f5f5f5",
              borderRadius: "8px",
            }}
          >
            <div
              style={{
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#e6f7ff",
              }}
            >
              {activeGenderFilter === "men" && <UserRound size={18} color="#1890ff" />}
              {activeGenderFilter === "women" && <FaUserAlt size={18} color="#eb2f96" />}
              {activeGenderFilter === "kids" && <UsersRound size={18} color="#52c41a" />}
            </div>
            <p
              style={{
                fontSize: "14px",
                fontWeight: 600,
                margin: 0,
                textTransform: "capitalize",
                color: "#333",
              }}
            >
              {activeGenderFilter}
            </p>
          </div> */}

                {/* Categories List */}
                {genderCategories[activeGenderFilter]?.length > 0 ? (
                  genderCategories[activeGenderFilter].map((cat) => (
                    <div
                      key={cat.id}
                      className="category-item"
                      style={{
                        marginBottom: "7px",
                        borderBottom: "1px solid #eee",
                        paddingBottom: "7px",
                      }}
                    >
                      {/* Category Header */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          cursor: "pointer",
                          padding: "8px 5px",
                          // backgroundColor: "#f5f5f5",
                          borderRadius: "5px",
                          marginBottom: "0px",
                        }}
                        onClick={() => toggleCategory(cat.id)}
                      >
                        <p
                          style={{
                            fontSize: "10px",
                            marginBottom: "0px",
                            fontWeight: "500",
                          }}
                        >
                          {cat.name}
                        </p>
                        <span style={{ color: "#007BFF", fontSize: "12px" }}>
                          {categoryExpandedSections[cat.id] ? (
                            <FaAngleUp />
                          ) : (
                            <FaAngleDown />
                          )}
                        </span>
                      </div>

                      {/* Subcategory List */}
                      {categoryExpandedSections[cat.id] && cat.subcategory && (
                        <div
                          className="subcategory-list"
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "8px",
                            marginLeft: "10px",
                            marginTop: "7px",
                          }}
                        >
                          {cat.subcategory.map((subcat) => (
                            <button
                              key={subcat.id}
                              onClick={() =>
                                handel3dRender(activeGenderFilter, subcat)
                              }
                              style={{
                                padding: "6px 12px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                backgroundColor: "#fff",
                                color: "#333",
                                cursor: "pointer",
                                fontSize: "11px",
                                fontFamily: "Poppins, sans-serif",
                                transition: "all 0.2s ease",
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.backgroundColor = "#f0f0f0";
                                e.target.style.borderColor = "#007BFF";
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.backgroundColor = "#fff";
                                e.target.style.borderColor = "#ddd";
                              }}
                            >
                              {subcat.name}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "20px",
                      color: "#999",
                      fontStyle: "italic",
                      fontSize: "13px",
                    }}
                  >
                    Loading categories for {activeGenderFilter}...
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {expandedSections.pattern && (
        <div
          className={`Subdesign-section ${
            expandedSections.pattern ? "show" : ""
          }`}
          ref={subdesignRef}
          style={{
            flexDirection: "column",
            marginTop: isMobile ? "10px" : "",
            height: isMobile ? "160px" : "",
            overflowY: "scroll",
            minHeight: isMobile ? "160px" : "",
            maxHeight: isMobile ? "700px" : "",
            width: isMobile ? "100%" : "",
            minWidth: isMobile ? "100%" : "",
            maxWidth: isMobile ? "100%" : "",
            paddingBottom: isMobile ? "80px" : "",
            WebkitOverflowScrolling: "touch",
            fontFamily: "Poppins, sans-serif",
          }}
        >
          <div
            className="design-section1 design-section-pattern"
            style={{
              padding: "10px",
              width: "100%",
              height: isMobile ? "180px" : "auto",
              overflowY: "scroll",
              paddingBottom: isMobile ? "80px" : "",
              borderRight: "1px solid rgb(203, 198, 198)",
              paddingTop: isMobile ? "0px" : "37px",
              fontFamily: "Poppins, sans-serif",
              display: "flex",
              flexDirection: "column",
              paddingBottom: "60px",
            }}
          >
            {Array.isArray(state.parts) && state.parts.length > 0 ? (
              state.parts
                .filter((part) => !EXCLUDED_PARTS_PATTERN.includes(part))
                .map((part, index) => {
                  const hasPattern = productData.selectedPattern?.[part];
                  const patternColor = productData.patternColors?.[part];

                  return (
                    <div
                      key={part}
                      className="pattern-section"
                      style={{
                        marginBottom: isMobile ? "3px" : "0px",
                        paddingTop: isMobile ? "3px" : "0px",
                        fontFamily: "Poppins, sans-serif",
                      }}
                    >
                      {/* Pattern Section Dropdown Header */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          cursor: "pointer",
                          padding: "4px 0",
                          width: "100%",
                        }}
                        onClick={() => {
                          const fieldKey = `${part}-pattern-section`;
                          setActiveTextField(
                            activeTextField === fieldKey ? null : fieldKey
                          );
                        }}
                      >
                        <p
                          className="pattern-section-para"
                          style={{
                            fontSize: "13px",
                            margin: 0,
                            fontFamily: "Poppins, sans-serif",
                            fontWeight: 400,
                          }}
                        >
                          {`${index + 1}. ${getDisplayName(part)} Pattern:`}
                        </p>
                        <span style={{ color: "#007BFF" }}>
                          {activeTextField === `${part}-pattern-section` ? (
                            <FaAngleUp />
                          ) : (
                            <FaAngleDown />
                          )}
                        </span>
                      </div>

                      {/* Conditionally render pattern selection and color section */}
                      {activeTextField === `${part}-pattern-section` && (
                        <div style={{ marginTop: isMobile ? "10px" : "15px" }}>
                          <div
                            className="pattern-selection"
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              alignItems: "center",
                              justifyContent: "flex-start",
                              marginLeft: "10px",
                              paddingLeft: "10px",
                              paddingTop: "10px",
                              marginTop: isMobile ? "0px" : "0px",
                              gap: "10px",
                              overflowY: isMobile ? "hidden" : "scroll",
                              overflowX: isMobile ? "scroll" : "hidden",
                              width: isMobile ? "100vw" : "",
                              minWidth: isMobile ? "100vw" : "",
                              maxWidth: isMobile ? "fit-content" : "",
                              display: "flex",
                              flexWrap: isMobile ? "nowrap" : "wrap",
                            }}
                          >
                            {patterns.map((pattern) => (
                              <div
                                key={`${part}-${pattern.name}`}
                                className={`pattern-thumbnail pattern-thumbnail2 ${
                                  productData.selectedPattern?.[part]?.name ===
                                  pattern.name
                                    ? "active"
                                    : ""
                                }`}
                                style={{
                                  border:
                                    productData.selectedPattern?.[part]
                                      ?.name === pattern.name
                                      ? "3px solid #007BFF"
                                      : "2px solid #ddd",
                                  padding: "4px",
                                  cursor: "pointer",
                                  flexShrink: 0,
                                  transform:
                                    productData.selectedPattern?.[part]
                                      ?.name === pattern.name
                                      ? "scale(1.1)"
                                      : "scale(1)",
                                  boxSizing: "border-box",
                                }}
                                onClick={() =>
                                  handlePatternSelect(part, pattern)
                                }
                              >
                                <img
                                  src={pattern.image}
                                  alt={pattern.name}
                                  style={{
                                    width: isMobile ? "100%" : "100%",
                                    height: isMobile ? "100%" : "100%",
                                    objectFit: "cover",
                                    borderRadius: isMobile ? "50%" : "10px",
                                  }}
                                />
                              </div>
                            ))}
                          </div>

                          {/* Pattern Color Section */}
                          <div
                            className="pattern-color-section"
                            style={{ width: "100%" }}
                          >
                            <div
                              className="pattern-color-header"
                              onClick={(e) => {
                                e.stopPropagation();
                                const fieldKey = `${part}-pattern-color`;
                                setActivePatternColor(
                                  activePatternColor === fieldKey
                                    ? null
                                    : fieldKey
                                );
                              }}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                cursor: "pointer",
                                marginTop: "15px",
                                padding: "10px",
                                backgroundColor: "#f5f5f5",
                                borderRadius: "5px",
                                width: "100%",
                                fontFamily: "Poppins, sans-serif",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "13px",
                                  fontWeight: 500,
                                  color: "#333",
                                  fontFamily: "Poppins, sans-serif",
                                }}
                              >
                                {getDisplayName(part)} Pattern Color
                              </span>
                              <span style={{ color: "#007BFF" }}>
                                {activePatternColor ===
                                `${part}-pattern-color` ? (
                                  <FaAngleUp />
                                ) : (
                                  <FaAngleDown />
                                )}
                              </span>
                            </div>

                            {activePatternColor === `${part}-pattern-color` && (
                              <div
                                className="pattern-color-content"
                                style={{
                                  padding: "0px 10px",
                                  backgroundColor: "#f9f9f9",
                                  fontFamily: "Poppins, sans-serif",
                                }}
                              >
                                {/* Color Options Grid */}
                                <div className="color-options-grid mb-10">
                                  {colorOptions.map((color, idx) => (
                                    <div
                                      key={idx}
                                      className={`color-option ${
                                        isMobile ? "mobile" : ""
                                      } ${
                                        color === (patternColor || "#ffffff")
                                          ? "selected"
                                          : "unselected"
                                      }`}
                                      onClick={() =>
                                        handlePatternColorChange(part, color)
                                      }
                                      style={{ backgroundColor: color }}
                                      title={color}
                                    />
                                  ))}
                                </div>

                                {/* Custom Color Input */}
                                <div className="custom-color-input-group">
                                  <div
                                    className="custom-color-preview"
                                    style={{
                                      width: "30px",
                                      height: "30px",
                                      borderRadius: "5px",
                                      marginRight: "10px",
                                      backgroundColor:
                                        patternColor || "#ffffff",
                                      border: "1px solid #ccc",
                                      boxShadow: "0 0 0 1px white inset",
                                    }}
                                  />

                                  <div
                                    className="custom-color-inputs"
                                    style={{
                                      flex: 1,
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <input
                                      type="text"
                                      className="hex-input"
                                      value={patternColor || "#ffffff"}
                                      onChange={(e) =>
                                        handlePatternColorChange(
                                          part,
                                          e.target.value
                                        )
                                      }
                                      maxLength={7}
                                      placeholder="#FFFFFF"
                                      style={{
                                        width: "100px",
                                        padding: "5px",
                                        fontSize: "12px",
                                        border: "1px solid #ccc",
                                        borderRadius: "3px",
                                        marginRight: "10px",
                                        fontFamily: "Poppins, sans-serif",
                                        height: "30px",
                                      }}
                                    />

                                    <input
                                      type="color"
                                      className="color-picker-input"
                                      value={patternColor || "#ffffff"}
                                      onChange={(e) =>
                                        handlePatternColorChange(
                                          part,
                                          e.target.value
                                        )
                                      }
                                      title="Pattern Color Picker"
                                      style={{
                                        width: "30px",
                                        height: "30px",
                                        cursor: "pointer",
                                        borderRadius: "5px",
                                        border: "1px solid #ccc",
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })
            ) : (
              <p
                style={{ fontFamily: "Poppins, sans-serif", fontSize: "13px" }}
              >
                No parts found
              </p>
            )}
          </div>
        </div>
      )}

      {expandedSections.images && (
        <div
          className={`image-section-container ${
            isMobile ? "mobile" : "desktop"
          }`}
          ref={subdesignRef}
          style={{
            padding: 0,
            margin: 0,
            width: isMobile ? "100%" : "",
            overflowY: "scroll",
            paddingTop: isMobile ? "15px" : "",
            fontFamily: "Poppins, sans-serif",
            paddingBottom: "50px",
            marginBottom: "50px",
          }}
        >
          <div className="design-section1 design-section-image">
            <div
              className="image-selection-container image-selection-container1"
              style={{
                width: "100%",
                fontSize: "13px",
                fontFamily: "Poppins, sans-serif",
                borderRight: "1px solid rgb(203, 198, 198)",
                paddingRight: "9px",
                paddingTop: "17px",
                overflowY: "scroll",
                paddingBottom: "50px",
                marginBottom: "50px",
              }}
            >
              {Array.isArray(state.parts) && state.parts.length > 0 ? (
                state.parts
                  .filter((part) => !EXCLUDED_PARTS_IMAGES.includes(part))
                  .map((part, index) => {
                    const inputKey = `${part}-${
                      state.imagesPattern?.[part] ? "has-image" : "no-image"
                    }`;
                    return (
                      <div
                        key={part}
                        className="image-section-item"
                        style={{
                          marginBottom: "25px",
                          borderBottom:
                            index <
                            state.parts.filter(
                              (p) => !EXCLUDED_PARTS_IMAGES.includes(p)
                            ).length -
                              1
                              ? "1px solid #ddd"
                              : "none",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "14px",
                            fontWeight: 400,
                            marginBottom: "15px",
                            color: "#333",
                            borderBottom: "1px solid #ddd",
                            paddingBottom: "8px",
                            fontFamily: "Poppins, sans-serif",
                            lineHeight: "100%",
                            letterSpacing: "0px",
                          }}
                        >
                          {`${index + 1}. ${getDisplayName(part)}`}
                        </p>

                        <div
                          className="input-group"
                          style={{ marginBottom: "10px" }}
                        >
                          <input
                            ref={(el) => (fileInputRefs.current[part] = el)}
                            type="file"
                            accept="image/*"
                            onChange={(e) => handleFileUpload(e, part)}
                            style={{
                              width: "100%",
                              padding: "10px",
                              borderRadius: "4px",
                              border: "1px solid #ddd",
                              fontSize: "12px",
                              fontFamily: "Poppins, sans-serif",
                              backgroundColor: "white",
                              cursor: "pointer",
                            }}
                          />
                        </div>

                        <div
                          style={{
                            fontSize: "10px",
                            color: "#666",
                            marginTop: "5px",
                            marginBottom: "15px",
                            fontStyle: "italic",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        >
                          Recommended: 2220x2553px
                        </div>

                        {state.imagesPattern?.[part] && (
                          <div style={{ marginTop: "10px" }}>
                            <button
                              onClick={() => {
                                delete state.imagesPattern[part];
                                state.updateTrigger++;
                                if (fileInputRefs.current[part]) {
                                  fileInputRefs.current[part].value = "";
                                }
                              }}
                              style={{
                                background: "#ff4d4d",
                                color: "white",
                                border: "none",
                                padding: "8px 16px",
                                borderRadius: "4px",
                                cursor: "pointer",
                                fontSize: "12px",
                                fontFamily: "Poppins, sans-serif",
                                fontWeight: 400,
                                transition: "background-color 0.2s ease",
                                width: "fit-content",
                                minWidth: "120px",
                              }}
                              onMouseEnter={(e) =>
                                (e.target.style.backgroundColor = "#ff3333")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.backgroundColor = "#ff4d4d")
                              }
                            >
                              Delete Image
                            </button>
                          </div>
                        )}
                      </div>
                    );
                  })
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    color: "#666",
                    fontFamily: "Poppins, sans-serif",
                    fontSize: "13px",
                  }}
                >
                  No parts found
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {expandedSections.colors && (
        <div
          className={`color-section-container ${isMobile ? "mobile" : ""}`}
          ref={subdesignRef}
          style={{
            fontFamily: "Poppins, sans-serif",
          }}
        >
          <div
            className={`design-section1 ${isMobile ? "mobile" : ""}`}
            style={{ fontFamily: "Poppins, sans-serif" }}
          >
            <div
              className={`color-selection-container1 ${
                isMobile ? "mobile" : ""
              }`}
              style={{
                borderRight: "1px solid rgb(203, 198, 198)",
                fontFamily: "Poppins, sans-serif",
              }}
            >
              {!openedColorPart ? (
                <div className="all-parts-list">
                  {Array.isArray(state.parts) && state.parts.length > 0 ? (
                    state.parts
                      .filter((part) => !EXCLUDED_PARTS_COLORS.includes(part))
                      .map((part, index) => {
                        const partColor =
                          productData.partColors?.[part] || "#ffffff";
                        const isWhiteColor = partColor === "#ffffff";

                        return (
                          <div
                            key={part}
                            className={`part-item1 ${isMobile ? "mobile" : ""}`}
                            onClick={() => handleColorPartToggle(part)}
                            style={{ fontFamily: "Poppins, sans-serif" }}
                          >
                            <div className="color-item">
                              <div
                                className={`color-circle ${
                                  isMobile ? "mobile" : ""
                                } ${isWhiteColor ? "white" : "colored"}`}
                                style={{
                                  backgroundColor: partColor,
                                  borderColor: isWhiteColor
                                    ? "#333"
                                    : partColor,
                                }}
                              />

                              <span
                                className={`part-name ${
                                  isMobile ? "mobile" : ""
                                }`}
                                style={{
                                  fontSize: "13px",
                                  fontFamily: "Poppins, sans-serif",
                                  fontWeight: 400,
                                }}
                              >
                                {`${index + 1}. ${getDisplayName(part)}`}
                              </span>

                              <span className="right-arrow">
                                <FaAngleRight />
                              </span>
                            </div>
                          </div>
                        );
                      })
                  ) : (
                    <div
                      className="no-parts-message"
                      style={{
                        fontFamily: "Poppins, sans-serif",
                        fontSize: "13px",
                      }}
                    >
                      No parts found
                    </div>
                  )}
                </div>
              ) : (
                <div
                  className="single-part-color-selection"
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    marginBottom: "57px",
                  }}
                >
                  <div className="single-part-header">
                    <button
                      className="back-button"
                      onClick={() => setOpenedColorPart(null)}
                      title="Back to all parts"
                      style={{ fontFamily: "Poppins, sans-serif" }}
                    >
                      <FaChevronLeft />
                    </button>

                    <div className="current-part-display">
                      <div
                        className="current-color-circle"
                        style={{
                          backgroundColor:
                            productData.partColors?.[openedColorPart] ||
                            "#ffffff",
                          border: `2px solid ${
                            productData.partColors?.[openedColorPart]
                              ? productData.partColors[openedColorPart] ===
                                "#ffffff"
                                ? "#333"
                                : productData.partColors[openedColorPart]
                              : "#333"
                          }`,
                          boxShadow:
                            productData.partColors?.[openedColorPart] &&
                            productData.partColors[openedColorPart] !==
                              "#ffffff"
                              ? "0 0 0 2px white inset"
                              : "none",
                        }}
                      />
                      <span
                        className="current-part-name"
                        style={{
                          paddingRight: "15px",
                          fontSize: "13px",
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 500,
                        }}
                      >
                        {getDisplayName(openedColorPart)}
                      </span>
                    </div>
                  </div>

                  <div className="color-selection-section">
                    <div className="mb-10">
                      <span
                        className="color-label"
                        style={{
                          fontSize: "13px",
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 500,
                        }}
                      >
                        Select Color:
                      </span>

                      <div className="color-options-grid">
                        {colorOptions.map((color, idx) => {
                          const isSelected =
                            color ===
                            (productData.partColors?.[openedColorPart] ||
                              "#ffffff");

                          return (
                            <div
                              key={idx}
                              className={`color-option ${
                                isMobile ? "mobile" : ""
                              } ${isSelected ? "selected" : "unselected"}`}
                              onClick={() =>
                                handlePartColorChange(openedColorPart, color)
                              }
                              style={{ backgroundColor: color }}
                              title={color}
                            />
                          );
                        })}
                      </div>
                    </div>

                    <div className="custom-color-section">
                      <span
                        className="color-label"
                        style={{
                          fontSize: "13px",
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 500,
                        }}
                      >
                        Custom Color:
                      </span>

                      <div className="custom-color-input-group">
                        <div className="custom-color-inputs">
                          <input
                            type="text"
                            className={`hex-input ${isMobile ? "mobile" : ""}`}
                            value={
                              productData.partColors?.[openedColorPart] ||
                              "#ffffff"
                            }
                            onChange={(e) =>
                              handlePartColorChange(
                                openedColorPart,
                                e.target.value
                              )
                            }
                            maxLength={7}
                            placeholder="#FFFFFF"
                            style={{
                              width: "30%",
                              fontSize: "12px",
                              fontFamily: "Poppins, sans-serif",
                              height: "30px",
                            }}
                          />

                          <input
                            type="color"
                            className={`color-picker-input ${
                              isMobile ? "mobile" : ""
                            }`}
                            value={
                              productData.partColors?.[openedColorPart] ||
                              "#ffffff"
                            }
                            onChange={(e) =>
                              handlePartColorChange(
                                openedColorPart,
                                e.target.value
                              )
                            }
                            title="Color picker"
                            style={{ fontFamily: "Poppins, sans-serif" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {expandedSections.gradient && (
        <div
          className={`color-section-container ${isMobile ? "mobile" : ""}`}
          ref={subdesignRef}
          style={{
            fontFamily: "Poppins, sans-serif",
          }}
        >
          <div
            className={`design-section1 ${isMobile ? "mobile" : ""}`}
            style={{ fontFamily: "Poppins, sans-serif" }}
          >
            <div
              className={`color-selection-container1 ${
                isMobile ? "mobile" : ""
              }`}
              style={{
                borderRight: "1px solid rgb(203, 198, 198)",
                fontFamily: "Poppins, sans-serif",
              }}
            >
              {!openedGradientPart ? (
                <div className="all-parts-list">
                  {Array.isArray(state.parts) && state.parts.length > 0 ? (
                    state.parts
                      .filter((part) => !EXCLUDED_PARTS_GRADIENT.includes(part))
                      .map((part, index) => {
                        const gradientColor =
                          productData.gradientColors?.[part] || "#ffffff";
                        const isWhiteColor = gradientColor === "#ffffff";

                        return (
                          <div
                            key={part}
                            className={`part-item1 ${isMobile ? "mobile" : ""}`}
                            onClick={() => handleGradientPartToggle(part)}
                            style={{ fontFamily: "Poppins, sans-serif" }}
                          >
                            <div className="color-item">
                              <div
                                className={`color-circle ${
                                  isMobile ? "mobile" : ""
                                } ${isWhiteColor ? "white" : "colored"}`}
                                style={{
                                  backgroundColor: gradientColor,
                                  borderColor: isWhiteColor
                                    ? "#333"
                                    : gradientColor,
                                }}
                              />

                              <span
                                className={`part-name ${
                                  isMobile ? "mobile" : ""
                                }`}
                                style={{
                                  fontSize: "13px",
                                  fontFamily: "Poppins, sans-serif",
                                  fontWeight: 400,
                                }}
                              >
                                {`${index + 1}. ${getDisplayName(part)}`}
                              </span>

                              <span className="right-arrow">
                                <FaAngleRight />
                              </span>
                            </div>
                          </div>
                        );
                      })
                  ) : (
                    <div
                      className="no-parts-message"
                      style={{
                        fontFamily: "Poppins, sans-serif",
                        fontSize: "13px",
                      }}
                    >
                      No parts found
                    </div>
                  )}
                </div>
              ) : (
                <div
                  className="single-part-color-selection"
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    marginBottom: "57px",
                  }}
                >
                  <div className="single-part-header">
                    <button
                      className="back-button"
                      onClick={() => setOpenedGradientPart(null)}
                      title="Back to all parts"
                      style={{ fontFamily: "Poppins, sans-serif" }}
                    >
                      <FaChevronLeft />
                    </button>

                    <div className="current-part-display">
                      <div
                        className="current-color-circle"
                        style={{
                          backgroundColor:
                            productData.gradientColors?.[openedGradientPart] ||
                            "#ffffff",
                          border: `2px solid ${
                            productData.gradientColors?.[openedGradientPart]
                              ? productData.gradientColors[
                                  openedGradientPart
                                ] === "#ffffff"
                                ? "#333"
                                : productData.gradientColors[openedGradientPart]
                              : "#333"
                          }`,
                          boxShadow:
                            productData.gradientColors?.[openedGradientPart] &&
                            productData.gradientColors[openedGradientPart] !==
                              "#ffffff"
                              ? "0 0 0 2px white inset"
                              : "none",
                        }}
                      />
                      <span
                        className="current-part-name"
                        style={{
                          paddingRight: "15px",
                          fontSize: "13px",
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 500,
                        }}
                      >
                        {getDisplayName(openedGradientPart)}
                      </span>
                    </div>
                  </div>

                  <div className="color-selection-section">
                    <div className="mb-10">
                      <span
                        className="color-label"
                        style={{
                          fontSize: "13px",
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 500,
                        }}
                      >
                        Select Color:
                      </span>

                      <div className="color-options-grid">
                        {colorOptions.map((color, idx) => {
                          const isSelected =
                            color ===
                            (productData.gradientColors?.[openedGradientPart] ||
                              "#ffffff");

                          return (
                            <div
                              key={idx}
                              className={`color-option ${
                                isMobile ? "mobile" : ""
                              } ${isSelected ? "selected" : "unselected"}`}
                              onClick={() =>
                                handleGradientColorChange(
                                  openedGradientPart,
                                  color
                                )
                              }
                              style={{ backgroundColor: color }}
                              title={color}
                            />
                          );
                        })}
                      </div>
                    </div>

                    <div className="custom-color-section">
                      <span
                        className="color-label"
                        style={{
                          fontSize: "13px",
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 500,
                        }}
                      >
                        Custom Color:
                      </span>

                      <div className="custom-color-input-group">
                        <div className="custom-color-inputs">
                          <input
                            type="text"
                            className={`hex-input ${isMobile ? "mobile" : ""}`}
                            value={
                              productData.gradientColors?.[
                                openedGradientPart
                              ] || "#ffffff"
                            }
                            onChange={(e) =>
                              handleGradientColorChange(
                                openedGradientPart,
                                e.target.value
                              )
                            }
                            maxLength={7}
                            placeholder="#FFFFFF"
                            style={{
                              width: "30%",
                              fontSize: "12px",
                              fontFamily: "Poppins, sans-serif",
                              height: "30px",
                            }}
                          />

                          <input
                            type="color"
                            className={`color-picker-input ${
                              isMobile ? "mobile" : ""
                            }`}
                            value={
                              productData.gradientColors?.[
                                openedGradientPart
                              ] || "#ffffff"
                            }
                            onChange={(e) =>
                              handleGradientColorChange(
                                openedGradientPart,
                                e.target.value
                              )
                            }
                            title="Color picker"
                            style={{ fontFamily: "Poppins, sans-serif" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {expandedSections.text && (
        <div
          className={`text-section-container ${isMobile ? "mobile" : ""}`}
          ref={subdesignRef}
          style={{
            fontFamily: "Poppins, sans-serif",
          }}
        >
          <div
            className={`design-section1 ${isMobile ? "mobile" : ""}`}
            style={{
              overflowY: "auto",
              fontFamily: "Poppins, sans-serif",
              borderRight: "1px solid rgb(203, 198, 198)",
              paddingBottom: "179px",
            }}
          >
            <div
              className="text-selection-container"
              style={{
                fontFamily: "Poppins, sans-serif",
              }}
            >
              {/* Front Text Section */}
              <div className="text-side-section">
                {/* Front Side Header with toggle */}
                <div
                  className="text-side-header"
                  onClick={() => setFrontTextExpanded(!frontTextExpanded)}
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    marginBottom: "7px",
                  }}
                >
                  <p
                    className="text-side-title"
                    style={{
                      fontSize: "14px",
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 500,
                    }}
                  >
                    Front Side
                  </p>
                  <span className="text-toggle-icon">
                    {frontTextExpanded ? <FaAngleUp /> : <FaAngleDown />}
                  </span>
                </div>

                {/* Front Side Content - Conditionally rendered */}
                {frontTextExpanded && (
                  <>
                    {/* Enter Text Input */}
                    <div className="text-input-group">
                      <label
                        className="text-input-label"
                        style={{
                          fontSize: "13px",
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 500,
                        }}
                      >
                        Enter Text
                      </label>
                      <input
                        type="text"
                        className="text-input"
                        placeholder="Enter Text"
                        value={productData.frontText || ""}
                        onFocus={() => handleInputFocus('front')}
                        onChange={handleFrontTextChange}
                        style={{
                          fontSize: "12px",
                          fontFamily: "Poppins, sans-serif",
                        }}
                      />
                    </div>

                    {/* Font Selection */}
                    <div className="text-input-group">
                      <label
                        className="text-input-label"
                        style={{
                          fontSize: "13px",
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 500,
                        }}
                      >
                        Front Text Font:
                      </label>
                      <select
                        className="text-select"
                        value={
                          productData.textFonts?.front ||
                          productData.selectedFonts ||
                          "Arial"
                        }
                        onChange={(e) =>
                          handleTextFontChange(e.target.value, "front")
                        }
                        style={{
                          fontFamily: "Poppins, sans-serif",
                          fontSize: "12px",
                        }}
                      >
                        {[
                          "Arial",
                          "Verdana",
                          "Helvetica",
                          "Tahoma",
                          "Times New Roman",
                          "Georgia",
                          "Garamond",
                          "Courier New",
                          "Brush Script MT",
                          "Impact",
                          "Comic Sans MS",
                          "Palatino",
                          "Lucida Sans",
                          "Calibri",
                          "Cambria",
                          "Candara",
                          "Consolas",
                          "Constantia",
                          "Corbel",
                          "Franklin Gothic",
                          "Geneva",
                          "Segoe UI",
                          "Trebuchet MS",
                        ].map((font) => (
                          <option
                            key={font}
                            value={font}
                            style={{ fontFamily: font, fontSize: "12px" }}
                          >
                            {font}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Text Color Selection */}
                    <div className="text-color-section">
                      <label
                        className="text-input-label"
                        style={{
                          fontSize: "13px",
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 500,
                        }}
                      >
                        Front Text Colors:
                      </label>

                      {/* Color Options Grid */}
                      <div className="color-options-grid mb-15">
                        {colorOptions.map((color, idx) => (
                          <div
                            key={idx}
                            className={`color-option ${
                              isMobile ? "mobile" : ""
                            } ${
                              color ===
                              (productData.textColors?.front || "#ffffff")
                                ? "selected"
                                : "unselected"
                            }`}
                            onClick={() =>
                              handleTextColorChange("front", color)
                            }
                            style={{ backgroundColor: color }}
                            title={color}
                          />
                        ))}
                      </div>

                      {/* Custom Color Input */}
                      <div
                        className="custom-color-input-group"
                        style={{ marginTop: "15px" }}
                      >
                        <div className="custom-color-inputs">
                          <input
                            type="text"
                            className={`hex-input ${isMobile ? "mobile" : ""}`}
                            value={productData.textColors?.front || "#ffffff"}
                            onChange={(e) =>
                              handleTextColorChange("front", e.target.value)
                            }
                            maxLength={7}
                            placeholder="#FFFFFF"
                            style={{
                              width: "30%",
                              fontSize: "12px",
                              fontFamily: "Poppins, sans-serif",
                              height: "30px",
                            }}
                          />

                          <input
                            type="color"
                            className={`color-picker-input ${
                              isMobile ? "mobile" : ""
                            }`}
                            value={productData.textColors?.front || "#ffffff"}
                            onChange={(e) =>
                              handleTextColorChange("front", e.target.value)
                            }
                            title="Color picker"
                            style={{ fontFamily: "Poppins, sans-serif" }}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>

              {/* Back Text Section */}
              <div className="text-divider">
                {/* Back Side Header with toggle */}
                <div
                  className="text-side-header"
                  onClick={() => setBackTextExpanded(!backTextExpanded)}
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    marginBottom: "7px",
                  }}
                >
                  <p
                    className="text-side-title"
                    style={{
                      fontSize: "14px",
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 500,
                      marginTop: "16px",
                    }}
                  >
                    Back Side
                  </p>
                  <span className="text-toggle-icon">
                    {backTextExpanded ? <FaAngleUp /> : <FaAngleDown />}
                  </span>
                </div>

                {/* Back Side Content - Conditionally rendered */}
                {backTextExpanded && (
                  <>
                    {/* Enter Text Input */}
                    <div className="text-input-group">
                      <label
                        className="text-input-label"
                        style={{
                          fontSize: "13px",
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 500,
                        }}
                      >
                        Enter Text
                      </label>
                      <input
                        type="text"
                        className="text-input"
                        placeholder="Enter Text"
                        value={productData.backText || ""}
                        onChange={handleBackTextChange}
                        onFocus={() => handleInputFocus('back')}
                        style={{
                          fontSize: "12px",
                          fontFamily: "Poppins, sans-serif",
                        }}
                      />
                    </div>

                    {/* Font Selection */}
                    <div className="text-input-group">
                      <label
                        className="text-input-label"
                        style={{
                          fontSize: "13px",
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 500,
                        }}
                      >
                        Back Text Font:
                      </label>
                      <select
                        className="text-select"
                        value={
                          productData.textFonts?.back ||
                          productData.selectedFonts ||
                          "Arial"
                        }
                        onChange={(e) =>
                          handleTextFontChange(e.target.value, "back")
                        }
                        style={{
                          fontFamily: "Poppins, sans-serif",
                          fontSize: "12px",
                        }}
                      >
                        {[
                          "Arial",
                          "Verdana",
                          "Helvetica",
                          "Tahoma",
                          "Times New Roman",
                          "Georgia",
                          "Garamond",
                          "Courier New",
                          "Brush Script MT",
                          "Impact",
                          "Comic Sans MS",
                          "Palatino",
                          "Lucida Sans",
                          "Calibri",
                          "Cambria",
                          "Candara",
                          "Consolas",
                          "Constantia",
                          "Corbel",
                          "Franklin Gothic",
                          "Geneva",
                          "Segoe UI",
                          "Trebuchet MS",
                        ].map((font) => (
                          <option
                            key={font}
                            value={font}
                            style={{ fontFamily: font, fontSize: "12px" }}
                          >
                            {font}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Text Color Selection */}
                    <div className="text-color-section text-color-section1">
                      <label
                        className="text-input-label"
                        style={{
                          fontSize: "13px",
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 500,
                        }}
                      >
                        Back Text Colors:
                      </label>

                      {/* Color Options Grid */}
                      <div className="color-options-grid mb-15">
                        {colorOptions.map((color, idx) => (
                          <div
                            key={idx}
                            className={`color-option ${
                              isMobile ? "mobile" : ""
                            } ${
                              color ===
                              (productData.textColors?.back || "#ffffff")
                                ? "selected"
                                : "unselected"
                            }`}
                            onClick={() => handleTextColorChange("back", color)}
                            style={{ backgroundColor: color }}
                            title={color}
                          />
                        ))}
                      </div>

                      {/* Custom Color Input */}
                      <div
                        className="custom-color-input-group"
                        style={{ marginTop: "15px" }}
                      >
                        <div className="custom-color-inputs">
                          <input
                            type="text"
                            className={`hex-input ${isMobile ? "mobile" : ""}`}
                            value={productData.textColors?.back || "#ffffff"}
                            onChange={(e) =>
                              handleTextColorChange("back", e.target.value)
                            }
                            maxLength={7}
                            placeholder="#FFFFFF"
                            style={{
                              width: "30%",
                              fontSize: "12px",
                              fontFamily: "Poppins, sans-serif",
                              height: "30px",
                            }}
                          />

                          <input
                            type="color"
                            className={`color-picker-input ${
                              isMobile ? "mobile" : ""
                            }`}
                            value={productData.textColors?.back || "#ffffff"}
                            onChange={(e) =>
                              handleTextColorChange("back", e.target.value)
                            }
                            title="Color picker"
                            style={{ fontFamily: "Poppins, sans-serif" }}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {expandedSections.number && (
        <div
          className={`number-section-container ${isMobile ? "mobile" : ""}`}
          ref={subdesignRef}
          style={{
            fontFamily: "Poppins, sans-serif",
          }}
        >
          <div
            className={`design-section1 ${isMobile ? "mobile" : ""}`}
            style={{
              overflowY: "auto",
              fontFamily: "Poppins, sans-serif",
              borderRight: "1px solid rgb(203, 198, 198)",
              paddingBottom: "179px",
            }}
          >
            <div
              className="number-selection-container"
              style={{
                fontFamily: "Poppins, sans-serif",
              }}
            >
              {/* Front Number Section */}
              <div className="text-side-section">
                {/* Front Side Header with toggle */}
                <div
                  className="text-side-header"
                  onClick={() => setFrontNumberExpanded(!frontNumberExpanded)}
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    marginBottom: "7px",
                  }}
                >
                  <p
                    className="text-side-title"
                    style={{
                      fontSize: "14px",
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 500,
                    }}
                  >
                    Front Side
                  </p>
                  <span className="text-toggle-icon">
                    {frontNumberExpanded ? <FaAngleUp /> : <FaAngleDown />}
                  </span>
                </div>

                {/* Front Side Content - Conditionally rendered */}
                {frontNumberExpanded && (
                  <>
                    {/* Enter Number Input */}
                    <div className="text-input-group">
                      <label
                        className="text-input-label"
                        style={{
                          fontSize: "13px",
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 500,
                        }}
                      >
                        Enter number
                      </label>
                      <input
                        type="number"
                        className="text-input"
                        placeholder="Enter number"
                        value={productData.frontNumber || ""}
                        onChange={handleFrontNumberChange}
                        onFocus={() => handleInputFocus('front')}
                        style={{
                          fontSize: "12px",
                          fontFamily: "Poppins, sans-serif",
                        }}
                      />
                    </div>

                    {/* Font Selection */}
                    <div className="text-input-group">
                      <label
                        className="text-input-label"
                        style={{
                          fontSize: "13px",
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 500,
                        }}
                      >
                        Front number font:
                      </label>
                      <select
                        className="text-select"
                        value={
                          productData.numberFonts?.front ||
                          productData.selectedFonts ||
                          "Arial"
                        }
                        onChange={(e) =>
                          handleNumberFontChange(e.target.value, "front")
                        }
                        style={{
                          fontFamily: "Poppins, sans-serif",
                          fontSize: "12px",
                        }}
                      >
                        {[
                          "Arial",
                          "Verdana",
                          "Helvetica",
                          "Tahoma",
                          "Times New Roman",
                          "Georgia",
                          "Garamond",
                          "Courier New",
                          "Brush Script MT",
                          "Impact",
                          "Comic Sans MS",
                          "Palatino",
                          "Lucida Sans",
                          "Calibri",
                          "Cambria",
                          "Candara",
                          "Consolas",
                          "Constantia",
                          "Corbel",
                          "Franklin Gothic",
                          "Geneva",
                          "Segoe UI",
                          "Trebuchet MS",
                        ].map((font) => (
                          <option
                            key={font}
                            value={font}
                            style={{ fontFamily: font, fontSize: "12px" }}
                          >
                            {font}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Number Color Selection */}
                    <div className="text-color-section">
                      <label
                        className="text-input-label"
                        style={{
                          fontSize: "13px",
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 500,
                        }}
                      >
                        Front number Colour:
                      </label>

                      {/* Color Options Grid */}
                      <div className="color-options-grid mb-15">
                        {colorOptions.map((color, idx) => (
                          <div
                            key={idx}
                            className={`color-option ${
                              isMobile ? "mobile" : ""
                            } ${
                              color ===
                              (productData.numberColors?.front || "#ffffff")
                                ? "selected"
                                : "unselected"
                            }`}
                            onClick={() =>
                              handleNumberColorChange("front", color)
                            }
                            style={{ backgroundColor: color }}
                            title={color}
                          />
                        ))}
                      </div>

                      {/* Custom Color Input */}
                      <div
                        className="custom-color-input-group"
                        style={{ marginTop: "15px" }}
                      >
                        <div className="custom-color-inputs">
                          <input
                            type="text"
                            className={`hex-input ${isMobile ? "mobile" : ""}`}
                            value={productData.numberColors?.front || "#ffffff"}
                            onChange={(e) =>
                              handleNumberColorChange("front", e.target.value)
                            }
                            maxLength={7}
                            placeholder="#FFFFFF"
                            style={{
                              width: "30%",
                              fontSize: "12px",
                              fontFamily: "Poppins, sans-serif",
                              height: "30px",
                            }}
                          />

                          <input
                            type="color"
                            className={`color-picker-input ${
                              isMobile ? "mobile" : ""
                            }`}
                            value={productData.numberColors?.front || "#ffffff"}
                            onChange={(e) =>
                              handleNumberColorChange("front", e.target.value)
                            }
                            title="Color picker"
                            style={{ fontFamily: "Poppins, sans-serif" }}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>

              {/* Back Number Section */}
              <div className="text-divider">
                {/* Back Side Header with toggle */}
                <div
                  className="text-side-header"
                  onClick={() => setBackNumberExpanded(!backNumberExpanded)}
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    marginBottom: "7px",
                  }}
                >
                  <p
                    className="text-side-title"
                    style={{
                      fontSize: "14px",
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 500,
                    }}
                  >
                    Back Side
                  </p>
                  <span className="text-toggle-icon">
                    {backNumberExpanded ? <FaAngleUp /> : <FaAngleDown />}
                  </span>
                </div>

                {/* Back Side Content - Conditionally rendered */}
                {backNumberExpanded && (
                  <>
                    {/* Enter Number Input */}
                    <div className="text-input-group">
                      <label
                        className="text-input-label"
                        style={{
                          fontSize: "13px",
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 500,
                        }}
                      >
                        Enter number
                      </label>
                      <input
                        type="number"
                        className="text-input"
                        placeholder="Enter number"
                        value={productData.backNumber || ""}
                        onChange={handleBackNumberChange}
                        onFocus={() => handleInputFocus('back')}
                        style={{
                          fontSize: "12px",
                          fontFamily: "Poppins, sans-serif",
                        }}
                      />
                    </div>

                    {/* Font Selection */}
                    <div className="text-input-group">
                      <label
                        className="text-input-label"
                        style={{
                          fontSize: "13px",
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 500,
                        }}
                      >
                        Back number font:
                      </label>
                      <select
                        className="text-select"
                        value={
                          productData.numberFonts?.back ||
                          productData.selectedFonts ||
                          "Arial"
                        }
                        onChange={(e) =>
                          handleNumberFontChange(e.target.value, "back")
                        }
                        style={{
                          fontFamily: "Poppins, sans-serif",
                          fontSize: "12px",
                        }}
                      >
                        {[
                          "Arial",
                          "Verdana",
                          "Helvetica",
                          "Tahoma",
                          "Times New Roman",
                          "Georgia",
                          "Garamond",
                          "Courier New",
                          "Brush Script MT",
                          "Impact",
                          "Comic Sans MS",
                          "Palatino",
                          "Lucida Sans",
                          "Calibri",
                          "Cambria",
                          "Candara",
                          "Consolas",
                          "Constantia",
                          "Corbel",
                          "Franklin Gothic",
                          "Geneva",
                          "Segoe UI",
                          "Trebuchet MS",
                        ].map((font) => (
                          <option
                            key={font}
                            value={font}
                            style={{ fontFamily: font, fontSize: "12px" }}
                          >
                            {font}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Number Color Selection */}
                    <div className="text-color-section text-color-section1">
                      <label
                        className="text-input-label"
                        style={{
                          fontSize: "13px",
                          fontFamily: "Poppins, sans-serif",
                          fontWeight: 500,
                        }}
                      >
                        Back number Colour:
                      </label>

                      {/* Color Options Grid */}
                      <div className="color-options-grid mb-15">
                        {colorOptions.map((color, idx) => (
                          <div
                            key={idx}
                            className={`color-option ${
                              isMobile ? "mobile" : ""
                            } ${
                              color ===
                              (productData.numberColors?.back || "#ffffff")
                                ? "selected"
                                : "unselected"
                            }`}
                            onClick={() =>
                              handleNumberColorChange("back", color)
                            }
                            style={{ backgroundColor: color }}
                            title={color}
                          />
                        ))}
                      </div>

                      {/* Custom Color Input */}
                      <div
                        className="custom-color-input-group"
                        style={{ marginTop: "15px" }}
                      >
                        <div className="custom-color-inputs">
                          <input
                            type="text"
                            className={`hex-input ${isMobile ? "mobile" : ""}`}
                            value={productData.numberColors?.back || "#ffffff"}
                            onChange={(e) =>
                              handleNumberColorChange("back", e.target.value)
                            }
                            maxLength={7}
                            placeholder="#FFFFFF"
                            style={{
                              width: "30%",
                              fontSize: "12px",
                              fontFamily: "Poppins, sans-serif",
                              height: "30px",
                            }}
                          />

                          <input
                            type="color"
                            className={`color-picker-input ${
                              isMobile ? "mobile" : ""
                            }`}
                            value={productData.numberColors?.back || "#ffffff"}
                            onChange={(e) =>
                              handleNumberColorChange("back", e.target.value)
                            }
                            title="Color picker"
                            style={{ fontFamily: "Poppins, sans-serif" }}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {expandedSections.logo && (
        <div
          className="logo-section-container"
          ref={subdesignRef}
          style={{
            backgroundColor: "rgb(245, 245, 245)",
            borderRadius: "8px",
            marginTop: "10px",
            width: "20%",
            margin: 0,
            padding: 0,
            width: isMobile ? "100%" : "",
            height: isMobile ? "300px" : "",
            paddingTop: isMobile ? "15px" : 0,
            overflowY: "auto",
            WebkitOverflowScrolling: "touch",
            fontFamily: "Poppins, sans-serif",
            paddingRight: "7px",
          }}
        >
          <div className="design-section1 design-section-logo">
            <div
              className="logo-selection-container"
              style={{
                width: "100%",
                fontSize: "12px",
                fontFamily: "Poppins, sans-serif",
                borderRight: "1px solid rgb(203, 198, 198)",
              }}
            >
              {/* Front Logo Section */}
              <div style={{ marginBottom: "20px", marginTop: "7px" }}>
                <p
                  style={{
                    fontSize: "14px",
                    fontWeight: 400,
                    marginBottom: "15px",
                    color: "#333",
                    borderBottom: "1px solid #ddd",
                    paddingBottom: "8px",
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: "500",
                  }}
                >
                  Front Logo
                </p>

                {/* File Upload Input */}
                <div className="input-group" style={{ marginBottom: "15px" }}>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={frontHandleLogoUpload}
                    style={{
                      width: "100%",
                      padding: "10px",
                      borderRadius: "4px",
                      border: "1px solid #ddd",
                      fontSize: "12px",
                      fontFamily: "Poppins, sans-serif",
                      backgroundColor: "white",
                      cursor: "pointer",
                    }}
                  />
                </div>

                {/* Delete Logo Button */}
                <div style={{ marginTop: "10px" }}>
                  <button
                    onClick={handleDeleteFrontLogo}
                    style={{
                      background: "#ff4d4d",
                      color: "white",
                      border: "none",
                      padding: "8px 16px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      fontSize: "12px",
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 400,
                      transition: "background-color 0.2s ease",
                      width: "fit-content",
                      minWidth: "120px",
                    }}
                    onMouseEnter={(e) =>
                      (e.target.style.backgroundColor = "#ff3333")
                    }
                    onMouseLeave={(e) =>
                      (e.target.style.backgroundColor = "#ff4d4d")
                    }
                  >
                    Delete Logo
                  </button>
                </div>
              </div>

              {/* Back Logo Section */}
              <div
                className="logo-selection-margin"
                style={{
                  marginTop: "25px",
                  paddingTop: "20px",
                  borderTop: "1px solid #ddd",
                }}
              >
                <p
                  style={{
                    fontSize: "14px",
                    fontWeight: 400,
                    marginBottom: "15px",
                    color: "#333",
                    borderBottom: "1px solid #ddd",
                    paddingBottom: "8px",
                    fontFamily: "Poppins, sans-serif",
                    fontWeight: "500",
                  }}
                >
                  Back Logo
                </p>

                {/* File Upload Input */}
                <div className="input-group" style={{ marginBottom: "15px" }}>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={backHandleLogoUpload}
                    style={{
                      width: "100%",
                      padding: "10px",
                      borderRadius: "4px",
                      border: "1px solid #ddd",
                      fontSize: "12px",
                      fontFamily: "Poppins, sans-serif",
                      backgroundColor: "white",
                      cursor: "pointer",
                    }}
                  />
                </div>

                {/* Delete Logo Button */}
                <div style={{ marginTop: "10px" }}>
                  <button
                    onClick={handleDeleteBackLogo}
                    style={{
                      background: "#ff4d4d",
                      color: "white",
                      border: "none",
                      padding: "8px 16px",
                      borderRadius: "4px",
                      cursor: "pointer",
                      fontSize: "12px",
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 400,
                      transition: "background-color 0.2s ease",
                      width: "fit-content",
                      minWidth: "120px",
                    }}
                    onMouseEnter={(e) =>
                      (e.target.style.backgroundColor = "#ff3333")
                    }
                    onMouseLeave={(e) =>
                      (e.target.style.backgroundColor = "#ff4d4d")
                    }
                  >
                    Delete Logo
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* for men */}
      <div
        className={`Subdesign-section ${expandedSections.men ? "show" : ""}`}
        ref={subdesignRef}
        style={{ width: !isMobile ? "20.7%" : "" }}
      >
        <div
          style={{
            width: "100%",
            fontSize: "7px",
            minHeight: "80vh",
            paddingBottom: "15px",
            maxHeight: "80vh",
            overflowY: "scroll",
          }}
        >
          {expandedSections.men && (
            <div
              className="input-group"
              style={{
                marginTop: isMobile ? "23px" : "125px",

                paddingBottom: "16px",

                zIndex: "100",

                height: "fit-content",

                paddingLeft: "18px",

                opacity: "1",

                position: "relative",

                display: "flex",

                flexDirection: "column",

                flexWrap: "wrap",
                marginBottom: isMobile ? "23px" : "",
                borderRight: "1px solid rgb(203, 198, 198)",
              }}
            >
              {category.map((cat) => (
                <div style={{ marginBottom: "10px" }}>
                  <p style={{ fontSize: "10px", marginBottom: 0 }}>
                    {cat.name}
                  </p>
                  {cat.subcategory.map((subcat) => (
                    <button
                      key={subcat.id}
                      onClick={() => handel3dRender("men", subcat)}
                      className="hover:bg-black hover:text-white"
                      style={{
                        margin: "2px",
                        padding: "4px 8px",
                        border: "0.4px solid #333",
                        borderRadius: "8px",

                        cursor: "pointer",
                        transition: "background-color 0.3s",
                        width: "max-content",
                        fontSize: "8px",
                      }}
                    >
                      {subcat.name}
                    </button>
                  ))}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* for women */}
      <div
        className={`Subdesign-section ${expandedSections.women ? "show" : ""}`}
        ref={subdesignRef}
        style={{ width: !isMobile ? "20.7%" : "" }}
      >
        <div
          style={{
            width: "100%",
            fontSize: "7px",
            minHeight: "80vh",
            paddingBottom: "15px",
            maxHeight: "80vh",
            overflowY: "scroll",
          }}
        >
          {expandedSections.women && (
            <div
              className="input-group"
              style={{
                marginTop: isMobile ? "23px" : "125px",

                paddingBottom: "16px",

                zIndex: "100",

                height: "fit-content",

                paddingLeft: "18px",

                opacity: "1",

                position: "relative",

                display: "flex",

                flexDirection: "column",

                flexWrap: "wrap",
                marginBottom: isMobile ? "23px" : "",
                borderRight: "1px solid rgb(203, 198, 198)",
              }}
            >
              {category.map((cat) => (
                <div style={{ marginBottom: "10px" }}>
                  <p style={{ fontSize: "10px", marginBottom: 0 }}>
                    {cat.name}
                  </p>
                  {cat.subcategory.map((subcat) => (
                    <button
                      key={subcat.id}
                      onClick={() => handel3dRender("women", subcat)}
                      className="hover:bg-black hover:text-white"
                      style={{
                        margin: "2px",
                        padding: "4px 8px",
                        border: "0.4px solid #333",
                        borderRadius: "8px",

                        cursor: "pointer",
                        transition: "background-color 0.3s",
                        width: "max-content",
                        fontSize: "8px",
                      }}
                    >
                      {subcat.name}
                    </button>
                  ))}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      {/* for kids */}
      <div
        className={`Subdesign-section ${expandedSections.kids ? "show" : ""}`}
        ref={subdesignRef}
        style={{ width: !isMobile ? "20.7%" : "" }}
      >
        <div
          style={{
            width: "100%",
            fontSize: "7px",
            minHeight: "80vh",
            paddingBottom: "15px",
            maxHeight: "80vh",
            overflowY: "scroll",
          }}
        >
          {expandedSections.kids && (
            <div
              className="input-group"
              style={{
                marginTop: isMobile ? "23px" : "125px",

                paddingBottom: "16px",

                zIndex: "100",

                height: "fit-content",

                paddingLeft: "18px",

                opacity: "1",

                position: "relative",

                display: "flex",

                flexDirection: "column",

                flexWrap: "wrap",
                marginBottom: isMobile ? "23px" : "",
                borderRight: "1px solid rgb(203, 198, 198)",
              }}
            >
              {category.map((cat) => (
                <div style={{ marginBottom: "10px" }}>
                  <p style={{ fontSize: "10px", marginBottom: 0 }}>
                    {cat.name}
                  </p>
                  {cat.subcategory.map((subcat) => (
                    <button
                      key={subcat.id}
                      onClick={() => handel3dRender("kids", subcat)}
                      className="hover:bg-black hover:text-white"
                      style={{
                        margin: "2px",
                        padding: "4px 8px",
                        border: "0.4px solid #333",
                        borderRadius: "8px",

                        cursor: "pointer",
                        transition: "background-color 0.3s",
                        width: "max-content",
                        fontSize: "8px",
                      }}
                    >
                      {subcat.name}
                    </button>
                  ))}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Customizer;
